import {
  GET_PROFITABLE_REPORTS,
  GET_LIASONPROCESSOWNER,
  GET_PROJECT_NAMES,
  GET_PENDING_TASK,
  GET_TASK_DELAYS,
  GET_PROFITABLE_REPORT_COUNT,
  GET_LIAISON_PROJECT_NAMES,
  GET_DASHBOARD_DATA,
  GET_USER_DASHBOARD_DATA,
  GET_USER_DASHBOARD_TASK,
  GET_CIVIL_PROCESS_DATA,
  GET_DASHBOARD_AQUIRED_BUT_PLAN_APPROVAL_PENDING_ZONE_DATA,
  GET_DASHBOARD_AQUIRED_BUT_PLAN_APPROVAL_PENDING_PROJECT_DATA,
  GET_DASHBOARD_AQUIRED_BUT_PLAN_APPROVAL_PENDING_FILE_DATA,
  GET_DASHBOARD_PLAN_APPROVAL_APPLIED_ZONE_DATA,
  GET_DASHBOARD_PLAN_APPROVAL_APPLIED_PROJECT_DATA,
  GET_DASHBOARD_PLAN_APPROVAL_APPLIED_FILE_DATA,
  SET_FUNNEL_ITEM_ID,
  GET_DASHBOARD_STOCK_ZONE_DATA,
  GET_DASHBOARD_STOCK_PROJECT_DATA,
  GET_DASHBOARD_STOCK_PROJECT_SITE_DATA,
  GET_DASHBOARD_STOCK_AGING_ZONE_DATA,
  GET_DASHBOARD_STOCK_AGING_PROJECT_DATA,
  GET_DASHBOARD_STOCK_AGING_FILE_DATA,
  GET_DASHBOARD_LAND_AQUIRED_ZONE_DATA,
  GET_DASHBOARD_LAND_AQUIRED_PROJECT_DATA,
  GET_DASHBOARD_LAND_AQUIRED_FILE_DATA,
  GET_DASHBOARD_APPLAN_APPROVAL_ZONE_DATA,
  GET_DASHBOARD_APPLAN_APPROVAL_PROJECT_DATA,
  GET_DASHBOARD_APPLAN_APPROVAL_FILE_DATA,
  GET_DASHBOARD_LAND_AQUIRED_FINANCIAL_YEAR_DATA,
  GET_DASHBOARD_PLAN_APPROVAL_FINANCIAL_YEAR_DATA,
  GET_DASHBOARD_PLAN_APPROVED_TARGET_ACTUAL_FINANCIAL_YEAR_DATA,
  GET_DASHBOARD_DATA_DEPARTMENT,
  GET_DASHBOARD_DEPARTMENT,
  GET_LIAISON_PROCESS_PLAN_REPORT,
  GET_LIAISON_PROCESS_PLAN_REPORT_DETAIL,
  GET_MY_DASHBOARD_DATA_FILTER_USER,
  GET_DASHBOARD_CRM_PROJECT_OUTSTANDING,
  GET_DASHBOARD_CRM_PROJECT_OUTSTANDING_EXPORT,
  GET_DASHBOARD_CRM_SITE_OUTSTANDING,
  GET_DASHBOARD_CRM_PROJECT_TARGET,
  GET_DASHBOEAR_CRM_SITE_TARGET,
  GET_DASHBOARD_CRM_PROJECT_RECEIVED,
  GET_DASHBOARD_CRM_SITE_RECEIVED,
  GET_DASHBOARD_CRM_PROJECT_REALIZED,
  GET_DAHSBOARD_CRM_SITE_REALIZED,
  GET_DASHBOARD_CRM_PROJECT_NOT_REALIZED,
  GET_DAHSBOARD_CRM_SITE_NOT_REALIZED,
  GET_DASHBOARD_DATA_PRE_SALES,
  GET_DASHBOARD_DATA_MARKETING_FUNNEL,
  GET_GRN_ON_TIME_REPORT,
  GET_GRN_ON_TIME_REPORT_EXPORT,
  GET_VENDOR_LEAD_TIME_REPORT,
  GET_VENDOR_LEAD_TIME_REPORT_EXPORT,
  GET_STOCK_PROJECT,
  GET_PURCHASE_INVOICE_ON_TIME_KPI,
  GET_PURCHASE_INVOICE_ON_TIME_KPI_EXPORT,
  GET_PURCHASE_INVOICE_ON_TIME_KPI_REPORT,
  GET_PURCHASE_INVOICE_ON_TIME_KPI_REPORT_EXPORT,
  GET_MATERIAL_QUANTITY_REJECTION_KPI,
  GET_MATERIAL_QUANTITY_REJECTION_KPI_EXPORT,
  GET_MATERIAL_QUANTITY_REJECTION_KPI_REPORT,
  GET_MATERIAL_QUANTITY_REJECTION_KPI_REPORT_EXPORT,
  GET_INDENT_PURCHASE_ORDER_KPI_REPORT,
  GET_INDENT_PURCHASE_ORDER_KPI_REPORT_EXPORT,
  GET_DASHBOARD_DATA_REGISTRATION_TURN_AROUND_TIME,
  GET_REGISTRATION_TURNAROUND_TIME_REPORT,
  GET_REGISTRATION_TURNAROUND_TIME_REPORT_FILTER_PROJECT,
  GET_REGISTRATION_TURNAROUND_TIME_REPORT_FILTER_USER,
  GET_CIVIL_RESOURCE_REPORT,
  GET_ON_TIME_DELIVERY_KPI,
  GET_ON_TIME_DELIVERY_KPI_EXPORT,
  GET_ON_TIME_DELIVERY_KPI_REPORT,
  GET_ON_TIME_DELIVERY_KPI_REPORT_EXPORT,
  GET_PROCUREMENT_KPI_REPORT,
  GET_SALES_CRM_REPORT,
  GET_SALES_CRM_REPORT_EXPORT,
  GET_CRM_PROJECTS,
  GET_CIVIL_RESOURCE_REPORT_NON_MATERIAL,
  GET_SCALE_TYPE,
  GET_CRM_SITE,
  GET_CRM_SITE_DIMENSION,
  GET_KPI_SALES_REPORT,
  GET_KPI_SALES_REPORT_EXPORT,
  GET_KPI_SALES_REPORT_EXECUTIVE_FILTER,
  GET_KPI_SALES_REPORT_DETAILS,
  GET_KPI_SALES_REPORT_DETAILS_PROJECT_FILTER,
  GET_KPI_SALES_REPORT_DETAILS_EXPORT,
  GET_KPI_PRE_SALES_REPORT,
  GET_KPI_PRE_SALES_REPORT_EXPORT,
  GET_KPI_PRE_SALES_REPORT_EXECUTIVE_FILTER,
  GET_KPI_SALES_PRE_REPORT_DETAILS,
  GET_KPI_PRE_SALES_REPORT_DETAILS_PROJECT_FILTER,
  GET_KPI_SALES_PRE_REPORT_DETAILS_EXPORT,
  GET_KPI_SALES_CRM_REPORT,
  GET_KPI_SALES_CRM_REPORT_EXPORT,
  GET_KPI_SALES_CRM_REPORT_PROJECT_FILTER,
  GET_KPI_SALES_CRM_REPORT_SOURCE_FILTER,
  GET_KPI_SALES_CRM_REPORT_SALES_EXECUTIVE_FILTER,
  GET_KPI_SALES_REPORT2,
  GET_KPI_SALES_REPORT2_EXPORT,
  GET_KPI_SALES_SUMMARY_REPORT,
  GET_KPI_SALES_SUMMARY_REPORT_EXPORT,
  GET_KPI_SALES_SUMMARY_REPORT_DETAILS,
  GET_KPI_SALES_SUMMARY_REPORT_DETAILS_EXPORT,
  GET_KPI_TELECALLING_REPORT,
  GET_KPI_TELECALLING_REPORT_EXPORT,
  GET_KPI_SALES_REPORT_LEAD_ASSIGNED_DETAIL,
  GET_KPI_SALES_REPORT_LEAD_ASSIGNED_DETAIL_EXPORT,
  GET_KPI_SALES_REPORT_SITE_VISIT_DETAIL,
  GET_KPI_SALES_REPORT_CRM_CANCELLATION_DETAILS,
  GET_KPI_SALES_REPORT_CRM_BOOKING_DETAILS_EXPORT,
  GET_KPI_SALES_REPORT_CRM_BOOKING_DETAILS,
  GET_CAMPAIGN_REPORT,
  GET_CAMPAIGN_REPORT_EXPORT,
  GET_CAMPAIGN_REPORT_FILTER_CAMPAIGN,
  GET_KPI_SALES_REPORT_SITE_VISIT_DETAILS_EXPORT,
  GET_CAMPAIGN_PROJECT_REPORT_EXPORT,
  GET_CAMPAIGN_PROJECT_REPORT,
  GET_CAMPAIGN_PROJECT_REPORT_FILTER_PROJECT,
  GET_CAMPAIGN_ENQUIRY_REPORT_EXPORT,
  GET_CAMPAIGN_ENQUIRY_REPORT,
  GET_CAMPAIGN_BOOKING_REPORT_EXPORT,
  GET_CAMPAIGN_BOOKING_REPORT,
  GET_CAMPAIGN_BOOKING_CANCELLED_REPORT_EXPORT,
  GET_CAMPAIGN_BOOKING_CANCELLED_REPORT,
  GET_CAMPAIGN_SITE_VISIT_REPORT_EXPORT,
  GET_CAMPAIGN_SITE_VISIT_REPORT,
  GET_FINANCIAL_YEAR,
  GET_FINANCIAL_YEAR_SCALE_TYPE,
  GET_FINANCIAL_YEAR_SCALE_VALUE,
  GET_KPI_SALES_REPORT_CRM_CANCELLATION_DETAILS_EXPORT,
  GET_PRE_SALES_SITE_VISIT_EXPORT,
  GET_PRE_SALES_SITE_VISIT,
  GET_KPITELECALLING_FILTER_USER,
  GET_KPI_SALES_SUMMARY_FILTER_USER,
  GET_SALES_REPORT,
  GET_SALES_REPORT_EXPORT,
  GET_SALES_REPORT_SITE_VISIT_EXPORT,
  GET_SALES_REPORT_SITE_VISIT,
  GET_SALES_REPORT_PROSPECTIVE_CLIENT_EXPORT,
  GET_SALES_REPORT_PROSPECTIVE_CLIENT,
  GET_SALES_REPORT_FOLLOW_UP_EXPORT,
  GET_SALES_REPORT_FOLLOW_UP,
  GET_SALES_REPORT_BOOKING_EXPORT,
  GET_SALES_REPORT_BOOKING,
  GET_SALES_REPORT_CANCELLATION_EXPORT,
  GET_SALES_REPORT_CANCELLATION,
  GET_SALES_REPORT_HOT_PROSPECTIVE_CLIENT_EXPORT,
  GET_SALES_REPORT_HOT_PROSPECTIVE_CLIENT,
  GET_MONTH_WEEK,
  GET_SALES_REPORT_CLIENT_MEETING_EXPORT,
  GET_SALES_REPORT_CLIENT_MEETING,
  GET_SALES_REPORT_PLANNED_CP_MEETING_EXPORT,
  GET_SALES_REPORT_PLANNED_CP_MEETING,
  GET_SALES_REPORT_TEAM_EXPORT,
  GET_SALES_REPORT_TEAM,
  GET_SALES_REPORT_FILTER_TEAM,
  GET_SALES_REPORT_FILTER_USER,
  GET_SALES_REPORT_PLANNED_FOLLOW_UP,
  GET_SALES_REPORT_PLANNED_FOLLOW_UP_EXPORT,
  GET_SALES_REPORT_PLANNED_SITE_VISIT,
  GET_SALES_REPORT_PLANNED_SITE_VISIT_EXPORT,
  GET_KPI_SALES_REPORT_CRM_BOOKING_DETAIL_FILTER_PROJECT,
  GET_KPI_SALES_REPORT_CRM_CANCELLATION_DETAIL_FILTER_PROJECT,
  GET_KPI_SALES_REPORT_SITE_VISIT_DETAIL_FILTER_PROJECT,
  GET_SALES_REPORT_COMPLETED_CP_MEETING,
  GET_SALES_REPORT_COMPLETED_CP_MEETING_EXPORT,
  GET_SALES_REPORT_PLANNED_CLIENT_MEETING_EXPORT,
  GET_SALES_REPORT_PLANNED_CLIENT_MEETING,
  GET_SALES_REPORT_COMPLETED_CLIENT_MEETING_EXPORT,
  GET_SALES_REPORT_COMPLETED_CLIENT_MEETING,
  GET_SALES_REPORT_ENQUIRY_FOLLOW_UP,
  GET_SALES_REPORT_ENQUIRY_FOLLOW_UP_EXPORT,
  GET_SALES_CHANNEL_PARTNER_REPORT,
  GET_SALES_CHANNEL_PARTNER_REPORT_EXPORT,
  GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT,
  GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT_EXPORT,
  GET_SALES_CHANNEL_PARTNER_ENQUIRY_REPORT_EXPORT,
  GET_SALES_CHANNEL_PARTNER_ENQUIRY_REPORT,
  GET_SALES_CHANNEL_PARTNER_SITE_VISIT_REPORT_EXPORT,
  GET_SALES_CHANNEL_PARTNER_SITE_VISIT_REPORT,
  GET_SALES_CHANNEL_PARTNER_BOOKING_REPORT_EXPORT,
  GET_SALES_CHANNEL_PARTNER_BOOKING_REPORT,
  GET_SALES_CHANNEL_PARTNER_CANCELLATION_REPORT_EXPORT,
  GET_SALES_CHANNEL_PARTNER_CANCELLATION_REPORT,
  GET_SALES_CHANNEL_PARTNER_ENQUIRY_REPORT_FILTER_PROJECT,
  GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT_FILTER_PROJECT,
  GET_SALES_CHANNEL_PARTNER_SITE_VISIT_REPORT_FILTER_PROJECT,
  GET_SALES_CHANNEL_PARTNER_BOOKING_REPORT_FILTER_PROJECT,
  GET_SALES_CHANNEL_PARTNER_CANCELLATION_REPORT_FILTER_PROJECT,
  GET_SALES_SOURCE_REPORT,
  GET_SALES_SOURCE_REPORT_EXPORT,
  GET_SALES_SOURCE_PROJECT_REPORT,
  GET_SALES_SOURCE_PROJECT_REPORT_EXPORT,
  GET_SALES_SOURCE_ENQUIRY_REPORT_EXPORT,
  GET_SALES_SOURCE_ENQUIRY_REPORT,
  GET_SALES_SOURCE_SITE_VISIT_REPORT_EXPORT,
  GET_SALES_SOURCE_SITE_VISIT_REPORT,
  GET_SALES_SOURCE_BOOKING_REPORT_EXPORT,
  GET_SALES_SOURCE_BOOKING_REPORT,
  GET_SALES_SOURCE_CANCELLATION_REPORT_EXPORT,
  GET_SALES_SOURCE_CANCELLATION_REPORT,
  GET_SALES_SOURCE_ENQUIRY_REPORT_FILTER_PROJECT,
  GET_SALES_SOURCE_PROJECT_REPORT_FILTER_PROJECT,
  GET_SALES_SOURCE_SITE_VISIT_REPORT_FILTER_PROJECT,
  GET_SALES_SOURCE_BOOKING_REPORT_FILTER_PROJECT,
  GET_SALES_SOURCE_CANCELLATION_REPORT_FILTER_PROJECT,
  GET_ENQUIRY_SOURCE_CATEGORY,
  GET_ENQUIRY_SOURCE_FILTER,
  GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT_FILTER_CHANNEL_PARTNER,
  GET_SALES_CHANNEL_PARTNER_ON_BOARD_REPORT_EXPORT,
  GET_SALES_CHANNEL_PARTNER_ON_BOARD_REPORT,
  GET_SALES_CHANNEL_PARTNER_REPORT_FILTER_SALES_EXECUTIVE,
  GET_PRE_SALES_REPORT,
  GET_PRE_SALES_REPORT_FILTER_EXECUTIVE,
  GET_PRE_SALES_REPORT_FILTER_SOURCE_CATEGORY,
  GET_PRE_SALES_REPORT_FILTER_SOURCE,
  GET_PRE_SALES_REPORT_FILTER_PROJECT,
  GET_PRE_SALES_REPORT_EXPORT,
  GET_PRE_SALES_ENQUIRY_REPORT,
  GET_PRE_SALES_PROJECT_REPORT,
  GET_PRE_SALES_PROJECT_REPORT_EXPORT,
  GET_PRE_SALES_PROJECT_REPORT_FILTER_PROJECT,
  GET_PRE_SALES_ENQUIRY_REPORT_EXPORT,
  GET_PRE_SALES_ENQUIRY_OVER_DUE_REPORT,
  GET_PRE_SALES_ENQUIRY_OVER_DUE_REPORT_EXPORT,
  GET_SALES_REPORT_CANCELLATION_PREVIOUS_EXPORT,
  GET_SALES_REPORT_CANCELLATION_PREVIOUS,
  GET_SALES_REPORT_BOOKING_GROSS,
  GET_SALES_REPORT_BOOKING_GROSS_EXPORT,
  GET_PENDING_DASHBOARD_DATA,
  GET_PENDING_ACCOUNTABLE_DASHBOARD_DATA,
  GET_DASHBOARD_DEPARTMENT_DATA,
  GET_PENDING_RESPONSIBLE_DASHBOARD_DATA,
  GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN,
  GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_EXPORT,
  GET_DASHBOARD_DATA_DOCUMENTATION_PLAN,
  GET_DASHBOARD_DATA_DOCUMENTATION_PLAN_EXPORT,
  GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY,
  GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_EXPORT,
  GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY,
  GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_EXPORT,
  GET_DASHBOARD_DATA_BD_LEGAL_TASK_EXPORT,
  GET_DASHBOARD_DATA_BD_LEGAL_TASK,
  GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE,
  GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_EXPORT,
  GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_EXPORT,
  GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING,
  GET_DASHBOARD_DATA_COURT_CASE_EXPORT,
  GET_DASHBOARD_DATA_COURT_CASE,
  GET_DASHBOARD_DATA_PROJECT_TASK_PLAN,
  GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_EXPORT,
  GET_DASHBOARD_DATA_TODO_EXPORT,
  GET_DASHBOARD_DATA_TODO,
  GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_PROJECT,
  GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_PROCESS,
  GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_ACCOUNTABLE,
  GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_RESPONSIBLE,
  GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_RESPONSIBLE,
  GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_ACCOUNTABLE,
  GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_CATEGORY,
  GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_PROJECT,
  GET_DASHBOARD_DATA_ENQUIRY,
  GET_DASHBOARD_DATA_BD_LEGAL_TASK_FILTER_PROJECT,
  GET_DASHBOARD_DATA_BD_LEGAL_TASK_FILTER_ACCOUNTABLE,
  GET_DASHBOARD_DATA_BD_LEGAL_TASK_FILTER_RESPONSIBLE,
  GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_FILTER_PROJECT,
  GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_FILTER_ACCOUNTABLE,
  GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_FILTER_RESPONSIBLE,
  GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_FILTER_PROJECT,
  GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_FILTER_ACCOUNTABLE,
  GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_FILTER_RESPONSIBLE,
  GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_FILTER_PROJECT,
  GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_FILTER_RESPONSIBLE,
  GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_PROJECT,
  GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_PROCESS,
  GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_ACCOUNTABLE,
  GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_RESPONSIBLE,
  GET_DASHBOARD_DATA_COURT_CASE_FILTER_PROJECT,
  GET_DASHBOARD_DATA_COURT_CASE_FILTER_ACCOUNTABLE,
  GET_DASHBOARD_DATA_COURT_CASE_FILTER_RESPONSIBLE,
  GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_PROJECT,
  GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_TASK,
  GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_ACCOUNTABLE,
  GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_RESPONSIBLE,
  GET_DASHBOARD_DATA_TODO_FILTER_PROJECT,
  GET_DASHBOARD_DATA_TODO_FILTER_ACCOUNTABLE,
  GET_DASHBOARD_DATA_TODO_FILTER_RESPONSIBLE,
  GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_FILTER_ACCOUNTABLE,
  GET_SALES_REPORT_BOOKING_FILTER_STM,
  GET_SALES_REPORT_SITE_VISIT_FILTER_STM,
  GET_SALES_REPORT_FOLLOW_UP_FILTER_STM,
  GET_SALES_SOURCE_ENQUIRY_REPORT_FILTER_SOURCE,
  GET_SALES_SOURCE_SITE_VISIT_REPORT_FILTER_SOURCE,
  GET_SALES_SOURCE_BOOKING_REPORT_FILTER_SOURCE,
  GET_SALES_SOURCE_CANCELLATION_REPORT_FILTER_SOURCE,
  GET_DASHBOARD_DATA_PROJECT_SURVEY,
  GET_DASHBOARD_DATA_PROJECT_SURVEY_EXPORT,
  GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_PROJECT,
  GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_TASK,
  GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_ACCOUNTABLE,
  GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_RESPONSIBLE,
  GET_DASHBOARD_DATA_PROJECT_LEGAL,
  GET_DASHBOARD_DATA_PROJECT_LEGAL_EXPORT,
  GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_PROJECT,
  GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_TASK,
  GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_ACCOUNTABLE,
  GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_RESPONSIBLE,
  GET_DASHBOARD_DATA_ENQUIRY_EXPORT,
  GET_DASHBOARD_DATA_ENQUIRY_SOURCE,
  GET_DASHBOARD_DATA_ENQUIRY_PROJECT,
  GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED,
  GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_EXPORT,
  GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_PROJECT,
  GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_SOURCE,
  GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_PRE_SALES,
  GET_DASHBOARD_DATA_SITE_VISIT,
  GET_DASHBOARD_DATA_SITE_VISIT_EXPORT,
  GET_DASHBOARD_DATA_SITE_VISIT_PROJECT,
  GET_DASHBOARD_DATA_SITE_VISIT_SOURCE,
  GET_DASHBOARD_DATA_SITE_VISIT_STM,
  GET_DASHBOARD_DATA_SITE_VISIT_PRE_SALES,
  GET_DASHBOARD_DATA_SALES_BOOKING,
  GET_DASHBOARD_DATA_SALES_BOOKING_EXPORT,
  GET_DASHBOARD_DATA_SALES_BOOKIG_FILTER_PROJECT,
  GET_DASHBOARD_DATA_SALES_SOURCE,
  GET_DASHBOARD_DATA_SALES_BOOKIG_FILTER_BOOKEDBY,
  GET_DASHBOARD_DATA_CANCELLATION,
  GET_DASHBOARD_DATA_CANCELLATION_EXPORT,
  GET_DASHBOARD_DATA_CANCELLATION_PROJECT,
  GET_DASHBOARD_DATA_CANCELLATION_SOURCE,
  GET_DASHBOARD_DATA_CANCELLATION_STM,
  GET_DASHBOARD_DATA_COLLECTION,
  GET_DASHBOARD_DATA_COLLECTION_EXPORT,
  GET_DASHBOARD_DATA_COLLECTION_PROJECT,
  GET_DASHBOARD_DATA_COLLECTION_USER,
  GET_DASHBOARD_DATA_AGREEMENT,
  GET_DASHBOARD_DATA_AGREEMENT_EXPORT,
  GET_DASHBOARD_DATA_AGREEMENT_PROJECT,
  GET_DASHBOARD_DATA_AGREEMENT_USER,
  GET_DASHBOARD_DATA_REGISTRATION,
  GET_DASHBOARD_DATA_REGISTRATION_EXPORT,
  GET_DASHBOARD_DATA_REGISTRATION_PROJECT,
  GET_DASHBOARD_DATA_REGISTRATION_USER,
  GET_SALES_REPORT_AGREEMENT,
  GET_SALES_REPORT_AGREEMENT_EXPORT,
  GET_SALES_REPORT_REGISTRATION,
  GET_SALES_REPORT_REGISTRATION_EXPORT,
  GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP,
  GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_EXPORT,
  GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_FILTER_PROJECT,
  GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_FILTER_SOURCE,
  GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_FILTER_SOURCE_CATEGORY,
  GET_PRE_SALES_REPORT_FOLLOW_UP,
  GET_PRE_SALES_REPORT_FOLLOW_UP_FILTER_PROJECT,
  GET_PRE_SALES_REPORT_FOLLOW_UP_FILTER_SOURCE,
  GET_PRE_SALES_REPORT_FOLLOW_UP_FILTER_SOURCE_CATEGORY,
  GET_PRE_SALES_REPORT_FOLLOW_UP_EXPORT,
  GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT,
  GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_FILTER_PROJECT,
  GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_FILTER_SOURCE,
  GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_FILTER_SOURCE_CATEGORY,
  GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_EXPORT,
  GET_PRE_SALES_REPORT_ACTUAL_SALES,
  GET_PRE_SALES_REPORT_ACTUAL_SALES_EXPORT,
  GET_PRE_SALES_REPORT_ACTUAL_SALES_FILTER_PROJECT,
  GET_PRE_SALES_REPORT_ACTUAL_SALES_FILTER_SOURCE,
  GET_PRE_SALES_REPORT_ACTUAL_SALES_FILTER_SOURCE_CATEGORY,
  GET_PRE_SALES_REPORT_CANCELLATION_EXPORT,
  GET_PRE_SALES_REPORT_CANCELLATION,
  GET_PRE_SALES_REPORT_CANCELLATION_FILTER_PROJECT,
  GET_PRE_SALES_REPORT_CANCELLATION_FILTER_SOURCE,
  GET_PRE_SALES_REPORT_CANCELLATION_FILTER_SOURCE_CATEGORY,
  GET_PRE_SALES_REPORT_SITE_VISIT_PREVIOUS_ENQUIRY,
  GET_PRE_SALES_REPORT_SITE_VISIT_PREVIOUS_ENQUIRY_EXPORT,
  GET_PRE_SALES_REPORT_SITE_VISIT_ENQUIRY_PROJECT,
  GET_PRE_SALES_REPORT_SITE_VISIT_FILTER_ENQUIRY_SOURCE,
  GET_PRE_SALES_REPORT_SITE_VISIT_ENQUIRY_FILTER_SOURCE_CATEGORY,

  //lead report
  GET_LEAD_SALES_REPORT,
  GET_LEAD_SALES_REPORT_EXPORT,
  GET_LEAD_SALES_REPORT_FILTER_SOURCE,
  GET_LEAD_SALES_REPORT_FILTER_CATEGORY,
  GET_LEAD_SALES_REPORT_FILTER_SUB_SOURCE,
  GET_LEAD_SALES_ENQUIRY_REPORT,
  GET_LEAD_SALES_ENQUIRY_REPORT_EXPORT,
  GET_SALES_REPORT_PLANNED_FOLLOWUP_FILTER_PROJECT,
  GET_SALES_REPORT_FOLLOW_UP_FILTER_PROJECT,
  GET_SALES_REPORT_PLANNED_SITE_VISIT_FILTER_PROJECT,
  GET_SALES_REPORT_SITE_VISIT_FILTER_PROJECT,
  GET_SALES_REPORT_BOOKING_FILTER_PROJECT,
  GET_SALES_REPORT_CANCELLATION_FILTER_PROJECT,
  GET_SALES_REPORT_AGREEMENT_FILTER_PROJECT,
  GET_SALES_REPORT_REGISTRATION_FILTER_PROJECT,
  GET_SALES_REPORT_BOOKING_GROSS_FILTER_PROJECT,
  GET_SALES_REPORT_CANCELLATION_PREVIOUS_FILTER_REPORT,
  GET_SALES_REPORT_PLANNED_CP_MEETING_FILTER_PROJECT,
  GET_SALES_REPORT_PLANNED_COMPLETED_CP_MEETING_FILTER_PROJECT,
  GET_SALES_REPORT_PLANNED_CLIENT_MEETING_FILTER_PROJECT,
  GET_SALES_REPORT_COMPLETED_CLIENT_MEETING_FILTER_PROJECT,
  GET_SOURCE_SUMMARY_REPORT_ACTUAL_SITE_VISIT,
  GET_SOURCE_SUMMARY_REPORT_ACTUAL_SALES,
  GET_SOURCE_SUMMARY_REPORT_ACTUAL_SITE_VISIT_FILTER_PROJECT,

  //CALL SUMMARY
  GET_CALL_SUMMARY_REPORT,
  GET_SOURCE_SUMMARY_REPORT_CANCELLATION,
  GET_SOURCE_SUMMARY_ENQUIRY_REPORT_FILTER_PROJECT,
  GET_SOURCE_SUMMARY_REPORT_ACTUAL_SALES_FILTER_PROJECT,
  GET_SOURCE_SUMMARY_REPORT_CANCELLATION_FILTER_PROJECT,
  GET_SOURCE_SUMMARY_REPORT_ACTUAL_SITE_VISIT_EXPORT,
  GET_SOURCE_SUMMARY_REPORT_ACTUAL_SALES_EXPORT,
  GET_SOURCE_SUMMARY_REPORT_CANCELLATION_EXPORT,
  GET_LEAD_SALES_REPORT_FILTER_PROJECT,
  GET_CALL_SUMMARY_FILTER_EXECUTIVE,
  GET_CALL_SUMMARY_TOTAL_CALL_REPORT,
  GET_CALL_SUMMARY_REPEAT_CALL_REPORT,
  GET_CALL_SUMMARY_FRESH_CALL_REPORT,
  GET_PROCUMENT_REPORT,
  GET_PROCUMENT_REPORT_EXPORT,
  GET_PROCUMENT_REPORT_FILTER_PROJECT,
  GET_PROCUMENT_REPORT_FILTER_VENDOR,
  GET_PROCUMENT_REPORT_FILTER_ITEM,
  GET_CALL_SUMMARY_REPORT_EXPORT,
  GET_CALL_SUMMARY_TOTAL_CALL_REPORT_EXPORT,
  GET_CALL_SUMMARY_REPEAT_CALL_REPORT_EXPORT,
  GET_CALL_SUMMARY_FRESH_CALL_REPORT_EXPORT,
  GET_PRE_SALES_REPORT_FILTER_DEPARTMENT,
  GET_PROCUMENT_REPORT_DETAIL,

  //civil budget report
  GET_CIVIL_PROJECT_BUDGET_REPORT,
  GET_CIVIL_PROJECT_BUDGET_REPORT_EXPORT,
  GET_CIVIL_ACTIVITY_BUDGET_REPORT,
  GET_CIVIL_ACTIVITY_BUDGET_REPORT_EXPORT,
  GET_CIVIL_WBS_BUDGET_REPORT,
  GET_CIVIL_WBS_BUDGET_REPORT_EXPORT,
  GET_CIVIL_PROJECT_BUDGET_REPORT_FILTER_PROJECT,
  GET_CIVIL_WBS_BUDGET_REPORT_FILTER_PROJECT,
  GET_CIVIL_WBS_BUDGET_REPORT_FILTER_WBS,
  GET_CIVIL_ACTIVITY_BUDGET_REPORT_FILTER_ACTIVITY,
  GET_CIVIL_ACTIVITY_BUDGET_REPORT_FILTER_WBS,
  GET_CIVIL_ACTIVITY_BUDGET_REPORT_FILTER_PROJECT,
  GET_CIVIL_ACTIVITY_BUDGET_REPORT_ACTUAL_MATERIAL,
  GET_CIVIL_ACTIVITY_BUDGET_REPORT_ACTUAL_MATERIAL_EXPORT,
  GET_SOURCE_CATEGORY_SUMMARY_REPORT,
  GET_SUB_SOURCE_CATEGORY_SUMMARY_REPORT,
  GET_SOURCE_CATEGORY_SUMMARY_REPORT_EXPORT,
  GET_SUB_SOURCE_CATEGORY_SUMMARY_REPORT_EXPORT,
  GET_CIVIL_PROJECT_BEDGET_REPORT_ADMIN_EXPENSE,
  GET_CIVIL_PROJECT_BEDGET_REPORT_ADMIN_EXPENSE_EXPORT,
  GET_CIVIL_PROJECT_BEDGET_REPORT_PETTY_CASH_EXPORT,
  GET_CIVIL_PROJECT_BEDGET_REPORT_PETTY_CASH,

  //PROJECT DASHBOARD
  GET_BD_PROJECT_DASHBOARD,
  GET_BD_PROJECT_CONSOLIDATED_DASHBOARD,
  GET_COURT_CASE_DASHBOARD,
  GET_COURT_CASE_DASHBOARD_EXPORT,
  GET_BD_LAND_DISPUTE_DASHBOARD,
  GET_BD_LAND_DISPUTE_DASHBOARD_EXPORT,
  GET_LIAISON_PROSESS_PLAN_DASHBOARD,
  GET_LIAISON_PROSESS_PLAN_DASHBOARD_EXPORT,
  GET_LIAISON_DOCUMENTAION_TASK_PLAN_DASHBOARD,
  GET_LIAISON_DOCUMENTAION_TASK_PLAN_DASHBOARD_EXPORT,
  GET_PROJECT_FILE_AQUISTION_PENDING_DASHBOARD_EXPORT,
  GET_PROJECT_FILE_AQUISTION_PENDING_DASHBOARD,
  GET_APF_TASK_PLAN_QUERY_DASHBOARD,
  GET_APF_TASK_PLAN_QUERY_DASHBOARD_EXPORT,

  //SITE SUMMARY
  GET_SITE_SUMMARY_REPORT,
  GET_SITE_SUMMARY_DETAIL_REPORT,
  GET_SITE_STATUS,
  GET_SITE_SUMMARY_REPORT_FILTER_PROJECT,
  GET_SITE_SUMMARY_DETAIL_REPORT_FILTER_PROJECT,
  GET_SITE_SUMMARY_REPORT_EXPORT,
  GET_SITE_SUMMARY_DETAIL_REPORT_EXPORT,
  GET_BD_PROJECT_AQUISTION_DASHBOARD_FILTER_PROJECT,
  GET_TASK_DASHBOARD,
  GET_TASK_DASHBOARD_EXPORT,
  GET_ORGANIZATION_STRUCTURE,
  GET_CIVIL_WBS_PROGRESS,
  GET_CIVIL_ACTIVITY_PROGRESS,
  GET_BD_PROJECT_CONSOLIDATED_DASHBOARD_EXPORT,
  GET_CIVIL_ACTIVITY_PROGRESS1,
  GET_CIVIL_WBS_PROGRESS1,
  GET_BD_PROJECT_CONSOLIDATED_DASHBOARD_MD,
  GET_MOU_DASHBOARD,
  GET_ACQUISITION_DASHBOARD_EXPORT,
  GET_MOU_DASHBOARD_EXPORT,
  GET_ACQUISITION_DASHBOARD,
  GET_COMPLIANCE_ITEM_REPORT,
  GET_COMPLIANCE_ITEM_REPORT_DETAIL,
  GET_COMPLIANCE_ITEM_HR_REPORT,
  GET_COMPLIANCE_ITEM_HR_REPORT_FILTER_CATEGORY,
  GET_COMPLIANCE_GST_REPORT_FILTER_COMPANY,
  GET_COMPLIANCE_ITEM_HR_REPORT_FILTER_COMPANY,
  // ITR-calendar
  GET_COMPLIANCE_ITEM_ITR_REPORT,
  GET_COMPLIANCE_ITR_REPORT_FILTER_COMPANT,
  // TDS-calendar
  GET_COMPLIANCE_ITEM_TDS_REPORT,
  GET_COMPLIANCE_TDS_REPORT_FILTER_COMPANY,
  GET_BD_LEGAL_DASHBOARD,
  GET_BD_LEGAL_DASHBOARD_EXPORT,
  // Qc Report
  GET_QC_WORK_REPORT,
  GET_QC_WORK_REPORT_FILTER_PROJECT,
  GET_QC_WORK_REPORT_PASSING_DETAIL,
  GET_QC_OBSERVATION_REPORT_PASSING_DETAIL,
  GET_QC_WORK_REPORT_PASSING_DETAIL_EXPORT,
  GET_QC_OBSERVATION_REPORT_PASSING_DETAIL_EXPORT,
  GET_QC_WORK_REPORT_FILTER_HANDLED_BY,
  // Qc Observation
  GET_QC_OBSERVATION_REPORT,
  GET_QC_OBSERVATION_REPORT_HANDLED_BY,
  GET_QC_OBSERVATION_REPORT_FILTER_PROJECT,
  GET_QC_WORK_REPORT_DETAIL,
  GET_QC_WORK_REPORT_FILTER_RAISED_BY,
  GET_QC_WORK_REPORT_EXPORT,
  GET_QC_OBSERVATION_REPORT_FILTER_HANDLED_BY,
  GET_QC_OBSERVATION_REPORT_FILTER_RAISED_BY,
  GET_QC_OBSERVATION_REPORT_EXPORT,
  GET_QC_TRAINING_REPORT_EXPORT,
  GET_QC_WALK_THROUGH_REPORT_EXPORT,
  GET_QC_WALK_THROUGH_REPORT,
  GET_QC_TRAINING_REPORT,
  GET_QC_OBSERVATION_REPORT_DETAIL,
  GET_QC_TRAINING_REPORT_FILTER_PROJECT,
  GET_QC_WALK_THROUGH_REPORT_DETAIL,
  GET_QC_WALK_THROUGH_REPORT_DETAIL_EXPORT,
  GET_QC_WALK_THROUGH_REPORT_FILTER_PROJECT,
  GET_QC_TRAINING_REPORT_DETAIL,
  GET_QC_TRAINING_REPORT_DETAIL_EXPORT,
  //QC Report (Inspection)
  GET_QC_INSPECTION_REPORT,
  GET_QC_INSPECTION_REPORT_FILTER_PROJECT,
  GET_QC_INSPECTION_REPORT_DETAIL_EXPORT,
  GET_QC_INSPECTION_REPORT_DETAIL,
  GET_QC_INSPECTION_REPORT_EXPORT,
  GET_QC_OBSERVATION_REPORT_DETAIL_EXPORT,
  //Crm Booking Report
  GET_CRM_BOOKING_REPORT,
  GET_CRM_BOOKING_REPORT_EXPORT,
  GET_CRM_BOOKING_REPORT_FILTER_PROJECT,
  GET_CRM_BOOKING_REPORT_FILTER_SITE,
  GET_CRM_BOOKING_REPORT_FILTER_CRM_USER,
  GET_CRM_BOOKING_REPORT_FILTER_SITE_STATUS,
  GET_CRM_BOOKING_REPORT_DETAIL
} from "./types";

const initialState = {
  profitableReports: [],
  profitableReportCount: 0,
  LiasonProcessOwners: [],
  getProjectNames: [],
  getTaskDelays: [],
  getPendingTasks: [],
  getLisionProjectNames: [],
  DashboardData: [],
  myDashboardData: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  myDashboardTask: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  civilProcessProgressData: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getDashboardAcquiredButPlanApprovalPendingZoneData: {
    error: false,
    message: "",
    data: []
  },
  getDashboardAcquiredButPlanApprovalPendingProjectData: {
    error: false,
    message: "",
    data: []
  },
  getDashboardAcquiredButPlanApprovalPendingFileData: {
    error: false,
    message: "",
    data: []
  },
  getDashboardPlanApprovalAppliedZoneData: {
    error: false,
    message: "",
    data: []
  },
  getDashboardPlanApprovalAppliedProjectData: {
    error: false,
    message: "",
    data: []
  },
  getDashboardPlanApprovalAppliedFileData: {
    error: false,
    message: "",
    data: []
  },
  // getFunnelID:{
  //     data:""
  // }
  getBDDashboardDataDepartment: {
    error: false,
    message: "",
    data: []
  },
  getBDDashboardDepartment: {
    error: false,
    message: "",
    data: []
  },
  getLiaisonProcessPlanReport: {
    error: false,
    message: "",
    data: {
      data: [{}],
      dataTotal: [{}]
    },
    totalCount: 0
  },
  liaisonProcessPlanReportDetail: {
    error: false,
    message: "",
    data: []
  },
  getMyDashboardDataFilterUser: {
    error: false,
    message: "",
    data: []
  },
  getDashboardCrmProjectOutstanding: {
    error: false,
    message: "",
    data: []
  },
  getDashboardCrmProjectOutstandingExport: {
    error: false,
    message: "",
    data: []
  },
  getDashboardCrmSiteOutstanding: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardCrmProjectTarget: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardCrmSiteTarget: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardCrmProjectReceived: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardCrmSiteReceived: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardCrmProjectNotRealized: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardCrmSiteNotRealized: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  DashboardDataPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataMarketingFunnel: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //   nikhil
  getGRNOnTimeKPIReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getGRNOnTimeKPIReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorLeadTimeKPIReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorLeadTimeKPIReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getStockProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPurchaseInvoiceOnTimeKPI: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPurchaseInvoiceOnTimeKPIExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPurchaseInvoiceOnTimeKPIReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPurchaseInvoiceOnTimeKPIReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getMaterialQuantityRejectionKPI: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMaterialQuantityRejectionKPIExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getMaterialQuantityRejectionKPIReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMaterialQuantityRejectionKPIReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getIndentPurchaseOrderKPIReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getIndentPurchaseOrderKPIReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataRegistrationTurnaroundTime: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getRegistrationTurnaroundTimeReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getRegistrationTurnaroundTimeReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getRegistrationTurnaroundTimeReportFilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilResourceReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getOnTimeDeliveryKPIReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getOnTimeDeliveryKPIReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getOnTimeDeliveryKPI: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getOnTimeDeliveryKPIExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcurmentKpiReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesCrmReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesCrmReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmProjects: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilResourceReportNonMaterial: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getScaleType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSite: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSiteDimension: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getKpiSalesReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKpiSalesReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesReportExecutiveFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesReportDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesReportDetailProjectFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesReportDetailExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPIPreSalesReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPIPreSalesReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPIPreSalesReportExecutiveFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPIPreSalesReportDetails: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPIPreSalesReportProjectFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPIPreSalesReportDetailsExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesCrmReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesCrmReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesCrmReportProjectFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesCrmReportSourceFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesCrmReportSalesExecutiveFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getKPISalesReport2: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesReport2Export: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesSummaryReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesSummaryReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesSummaryReportDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesSummaryReportDetailExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPITelecallingReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPITelecallingReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPIPreSalesReportLeadAssignedDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPIPreSalesReportLeadAssignedDetailExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesReportSiteVisitDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesReportCrmBookingDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesReportCrmBookingDetailExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesReportCrmCancellationDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCampaignReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCampaignReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCampaignReportFilterCampaign: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesReportSiteVisitDetailExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCampaignProjectReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCampaignProjectReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCampaignProjectReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCampaignEnquiryReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCampaignEnquiryReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCampaignBookingReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCampaignBookingReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCampaignBookingCancelledReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCampaignBookingCancelledReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCampaignSiteVisitReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCampaignSiteVisitReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getFinancialYear: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getFinancialYearScaleType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getFinancialYearScaleValue: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesReportCrmCancellationDetailExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPIPreSalesSiteVisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPIPreSalesSiteVisitExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPITelecallingFilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesSummaryFilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportAgreement: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportAgreementExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportRegistration: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportRegistrationExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportSiteVisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportSiteVisitFilterStm: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getSalesReportFollowUpFilterStm: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getSalesReportBookingFilterStm: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportSiteVisitExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportFollowUp: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportFollowUpExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportProspectiveClient: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportProspectiveClientExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportBooking: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportBookingExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportCancellation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportCancellationExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportHotProspectiveClient: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportHotProspectiveClientExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMonthWeek: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportPlannedCpMeeting: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportPlannedCpMeetingExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportClientMeeting: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportClientMeetingExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportTeam: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportTeamExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportFilterTeam: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportFilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportPlannedFollowUp: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportPlannedFollowUpExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportPlannedSiteVisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportPlannedSiteVisitExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesReportCrmBookingDetailFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesReportCrmCancellationDetailFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getKPISalesReportSiteVisitDetailFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportCompletedCpMeeting: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportCompletedCpMeetingExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportPlannedClientMeeting: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportPlannedClientMeetingExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportCompletedClientMeeting: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportCompletedClientMeetingExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportEnquiryFollowUp: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportEnquiryFollowUpExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //cp sales report
  getSalesChannelPartnerReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerProjectReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerProjectReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerEnquiryReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerEnquiryReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerSiteVisitReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerSiteVisitReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerBookingReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerBookingReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerCancellationReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerCancellationReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerProjectReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerEnquiryReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerSiteVisitReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerBookingReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerCancellationReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //source sales report
  getSalesSourceReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceProjectReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceProjectReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceEnquiryReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getSalesSourceEnquiryReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceEnquiryReportFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceSiteVisitReportFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceBookingReportFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceCancellationReportFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceSiteVisitReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceSiteVisitReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceBookingReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceBookingReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceCancellationReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceCancellationReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceProjectReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceEnquiryReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceSiteVisitReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceBookingReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSourceCancellationReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEnquirySourceCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEnquirySourceFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerProjectReportFilterChannelPartner: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerOnBoardReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerOnBoardReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesChannelPartnerReportFilterSalesExecutive: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportFilterExecutive: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportFilterSourceCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesEnquiryReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesProjectReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesProjectReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesProjectReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesEnquiryReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesEnquiryOverdueReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesEnquiryOverdueReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportCancellationPrevious: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportCancellationPreviousExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportBookingGross: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportBookingGrossExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPendingDashboardData: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPendingTaskDashboardData: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPendingAccountableDashboardData: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDepartmentData: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPendingResponsibleDashboardData: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Liasion Process
  getDashboardDataLiaisonProcessPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataLiaisonProcessPlanExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataLiaisonProcessPlanFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataLiaisonProcessPlanFilterProcess: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataLiaisonProcessPlanFilterAccountable: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataLiaisonProcessPlanFilterResponsible: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Liasion Documentation
  getDashboardDataDocumentationPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataDocumentationPlanExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataLiaisonDocumentationFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataLiaisonDocumentationFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataLiaisonDocumentationFilterAccountable: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataLiaisonDocumentationFilterResponsible: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Apf Query
  getDashboardDataApfTaskPlanQuery: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataApfTaskPlanQueryExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataApfTaskPlanQueryFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataApfTaskPlanQueryFilterAccountable: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataApfTaskPlanQueryFilterResponsible: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Loan Query
  getDashboardDataLoanProcessPlanQuery: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataLoanProcessPlanQueryExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataLoanProcessPlanQueryFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataLoanProcessPlanQueryFilterProcess: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataLoanProcessPlanQueryFilterAccountable: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataLoanProcessPlanQueryFilterResponsible: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Legal task
  getDashboardDataBdLegalTask: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataBdLegalTaskExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataBdLegalTaskFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataBdLegalTaskFilterAccountable: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataBdLegalTaskFilterResponsible: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Boundary Dispute
  getDashboardDataBdLegalTaskDispute: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataBdLegalTaskDisputeExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataBdLegalTaskDisputeFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataBdLegalTaskDisputeFilterAccountable: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataBdLegalTaskDisputeFilterResponsible: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //To be Acquired
  getDashboardDataProjectFileAcquisitionPending: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectFileAcquisitionPendingExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectFileAcquisitionPendingFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectFileAcquisitionPendingFilterAccountable: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectFileAcquisitionPendingFilterResponsible: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Court Case
  getDashboardDataCourtCase: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataCourtCaseExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataCourtCaseFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataCourtCaseFilterAccountable: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataCourtCaseFilterResponsible: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //Project Task
  getDashboardDataProjectTaskPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectTaskPlanExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectTaskPlanFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectTaskPlanFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectTaskPlanFilterTask: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectTaskPlanFilterAccountable: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectTaskPlanFilterResponsible: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //To do
  getDashboardDataToDo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataToDoExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataToDoFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataToDoFilterAccountable: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataToDoFilterResponsible: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Survey
  getDashboardDataProjectSurvey: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectSurveyExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectSurveyFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectSurveyFilterTask: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectSurveyFilterAccountable: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectSurveyFilterResponsible: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Project Legal
  getDashboardDataProjectLegal: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectLegalExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectLegalFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectLegalFilterTask: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectLegalFilterAccountable: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataProjectLegalFilterResponsible: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //Marketing
  //Enquiry Generated
  getDashboardDataEnquiry: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataEnquiryExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataEnquiryProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataEnquirySource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //Enquiry Qualificated
  getDashboardDataEnquiryQualified: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataEnquiryQualifiedExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataEnquiryQualifiedProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataEnquiryQualifiedSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataEnquiryQualifiedPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //Pre-Sales
  //Site Visit
  getDashboardDataSiteVisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataSiteVisitExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataSiteVisitProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataSiteVisitSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataSiteVisitStm: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataSiteVisitSourcePreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //Sales
  //Sales
  getDashboardDataSalesBooking: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataSalesBookingExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataSalesBookingFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataSalesSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardDataSalesBookingFilterBookedBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //Cancellation
  getDashboardCancellation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardCancellationExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardCancellationProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardCancellationSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardCancellationStm: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //CRM
  //Collection
  getDashboardCollection: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardCollectionExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardCollectionProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardCollectionUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //Agreement
  getDashboardAgreement: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardAgreementExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardAgreementProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardAgreementUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //Registration
  getDashboardRegistration: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardRegistrationExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardRegistrationProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDashboardRegistrationUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportPlannedFollowUp: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportPlannedFollowUpExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportPlannedFollowUpFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportPlannedFollowUpFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportPlannedFollowUpFilterSourceCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportFollowUp: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportFollowUpFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportFollowUpFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportFollowUpFilterSourceCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportFollowUpExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportActualSiteVisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportActualSiteVisitFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportActualSiteVisitFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportActualSiteVisitFilterSourceCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportActualSiteVisitExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportActualSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportActualSalesExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportActualSalesFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportActualSalesFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportActualSalesFilterSourceCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportCancellation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportCancellationExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportCancellationFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportCancellationFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportCancellationFilterSourceCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportsiteVisitPreviousEnquiry: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportsiteVisitPreviousEnquiryExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportSiteVisitEnquiryFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportSiteVisitEnquiryFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesReportSiteVisitEnquiryFilterSourceCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //lead report
  getLeadSalesReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadSalesReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadSalesReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadSalesReportFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadSalesReportFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadSalesReportFilterSubSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadSalesEnquiryReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadSalesEnquiryReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceSummaryReportActualSiteVisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceSummaryReportActualSiteVisitExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceSummaryReportActualSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceSummaryReportActualSalesExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceSummaryReportCancellation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceSummaryReportCancellationExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceSummaryEnquiryReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //PROJECT FILTER
  getSalesReportPlannedFollowUpFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportFollowUpFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportPlannedSiteVisitFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportSiteVisitFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportBookingFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportCancellationFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportAgreementFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportRegistrationFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportBookingGrossFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportCancellationPreviousFilterReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportPlannedCpMeetingFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportCompletedCpMeetingFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReportPlannedClientMeetingFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceSummaryReportActualSiteVisitFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceSummaryReportActualSalesFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceSummaryReportCancellationFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //CALL SUMMARY
  getCallSummaryReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCallSummaryReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCallSummaryReportFilterExecutive: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCallSummaryTotalCallReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCallSummaryTotalCallReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCallSummaryRepeatCallReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCallSummaryRepeatCallReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCallSummaryFreshCallReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCallSummaryFreshCallReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcurmentReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcurmentReportDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcurmentReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcurmentReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcurmentReportFilterVendor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcurmentReportFilterItem: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //civil budget report
  getCivilProjectBudgetReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilProjectBudgetReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilActivityBudgetReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilActivityBudgetReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilWbsBudgetReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilWbsBudgetReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilProjectBudgetReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilWbsBudgetReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilWbsBudgetReportFilterWbs: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilActivityBudgetReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilActivityBudgetReportFilterWbs: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilActivityBudgetReportFilterActivity: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getCivilActivityBudgetReportActualMaterial: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilActivityBudgetReportActualMaterialExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSubSourceSummaryReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getSourceCategorySummaryReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSubSourceSummaryReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getSourceCategorySummaryReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilProjectBudgetReportAdminExpense: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilProjectBudgetReportAdminExpenseExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilProjectBudgetReportPettyCash: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilProjectBudgetReportPettyCashExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //DASHBOARD SERVICE

  getBDProjectDashboard: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getBdProjectConsolidatedDashboard: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getBdProjectConsolidatedDashboardExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getBdProjectConsolidatedDashboardMD: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCourtCaseDashboard: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCourtCaseDashboardExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getBdLandDisputeDashboard: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getBdLandDisputeDashboardExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getBdLegalDashboard: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getBdLegalDashboardExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLiaisonProcessPlanDashboard: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLiaisonProcessPlanDashboardExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLiaisonDocumentationTaskPlanDashboardExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLiaisonDocumentationTaskPlanDashboard: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectFileAcquisitionPendingDashboardExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectFileAcquisitionPendingDashboard: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getApfTaskPlanQueryDashboard: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getApfTaskPlanQueryDashboardExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //SITE SUMMARY
  getSiteSummaryReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteSummaryDetailReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteSummaryReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteSummaryDetailReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteSummaryReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteSummaryDetailReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectFileAcquisitionDashboardFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskDashboard: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskDashboardExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //ORG CHART
  getOrganizationStructure: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilWbsProgress: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilActivityProgress: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilWbsProgress1: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilActivityProgress1: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMouDashboard: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMouDashboardExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAcquisitionDashboard: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAcquisitionDashboardExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceItemReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceItemReportDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceItemHrReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceItemHrReportFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceGstReportFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceHrReportFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceItemItrReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceItrReportFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceItemTdsReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComplianceTdsReportFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Qc Report
  getQcWorkReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcWorkReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcWorkReportPassingDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcObservationReportPassingDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcWorkReportPassingDetailExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcObservationReportPassingDetailExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcWorkReportFilterHandledBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Qc Observation
  getQcObservationReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcObservationReportHandledBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcObservationReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcWalkthroughReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcTrainingReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcTrainingReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcObservationReportFilterHandledBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getQcObservationReportDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcObservationReportDetailExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcObservationReportFilterRaisedBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcObservationReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcWorkReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcWorkReportDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcWorkReportFilterRaisedBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcTrainingReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Qc Report
  getQcInspectionReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInspectionReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInspectionReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInspectionReportDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInspectionReportDetailExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Crm Booking Report
  getCrmBookingReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmBookingReportExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmBookingReportFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmBookingReportFilterSite: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmBookingReportFilterCrmUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmBookingReportFilterSiteStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmBookingReportDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  }
};

const Report_reducer = (state = initialState, { type, payload }) => {
  // console.log(type, "payload", payload)
  switch (type) {
    case GET_PROFITABLE_REPORTS:
      return Object.assign({}, state, { profitableReports: payload });
    case GET_PROFITABLE_REPORT_COUNT:
      return Object.assign({}, state, { profitableReportCount: payload });
    case GET_LIASONPROCESSOWNER:
      return Object.assign({}, state, { LiasonProcessOwners: payload });
    case GET_PROJECT_NAMES:
      return Object.assign({}, state, { getProjectNames: payload });
    case GET_LIAISON_PROJECT_NAMES:
      return Object.assign({}, state, { getLisionProjectNames: payload });
    case GET_TASK_DELAYS:
      return Object.assign({}, state, { getTaskDelays: payload });
    case GET_PENDING_TASK:
      return Object.assign({}, state, { getPendingTasks: payload });
    case GET_DASHBOARD_DATA:
      return Object.assign({}, state, { DashboardData: payload });
    case GET_USER_DASHBOARD_DATA:
      return Object.assign({}, state, { myDashboardData: payload });
    case GET_USER_DASHBOARD_TASK:
      return Object.assign({}, state, { myDashboardTask: payload });
    case GET_CIVIL_PROCESS_DATA:
      return Object.assign({}, state, { civilProcessProgressData: payload });
    case GET_DASHBOARD_AQUIRED_BUT_PLAN_APPROVAL_PENDING_ZONE_DATA:
      return Object.assign({}, state, {
        getDashboardAcquiredButPlanApprovalPendingZoneData: payload
      });
    case GET_DASHBOARD_AQUIRED_BUT_PLAN_APPROVAL_PENDING_PROJECT_DATA:
      return Object.assign({}, state, {
        getDashboardAcquiredButPlanApprovalPendingProjectData: payload
      });
    case GET_DASHBOARD_AQUIRED_BUT_PLAN_APPROVAL_PENDING_FILE_DATA:
      return Object.assign({}, state, {
        getDashboardAcquiredButPlanApprovalPendingFileData: payload
      });
    case GET_DASHBOARD_PLAN_APPROVAL_APPLIED_ZONE_DATA:
      return Object.assign({}, state, {
        getDashboardPlanApprovalAppliedZoneData: payload
      });
    case GET_DASHBOARD_PLAN_APPROVAL_APPLIED_PROJECT_DATA:
      return Object.assign({}, state, {
        getDashboardPlanApprovalAppliedProjectData: payload
      });
    case GET_DASHBOARD_PLAN_APPROVAL_APPLIED_FILE_DATA:
      return Object.assign({}, state, {
        getDashboardPlanApprovalAppliedFileData: payload
      });
    case SET_FUNNEL_ITEM_ID:
      return Object.assign({}, state, { getFunnelID: payload });
    case GET_DASHBOARD_STOCK_ZONE_DATA:
      return Object.assign({}, state, { getDashboardStockZoneData: payload });
    case GET_DASHBOARD_STOCK_PROJECT_DATA:
      return Object.assign({}, state, {
        getDashboardStockProjectData: payload
      });
    case GET_DASHBOARD_STOCK_PROJECT_SITE_DATA:
      return Object.assign({}, state, {
        getDashboardStockProjectSiteData: payload
      });
    case GET_DASHBOARD_STOCK_AGING_ZONE_DATA:
      return Object.assign({}, state, {
        getDashboardStockAgingZoneData: payload
      });
    case GET_DASHBOARD_STOCK_AGING_PROJECT_DATA:
      return Object.assign({}, state, {
        getDashboardStockAgingProjectData: payload
      });
    case GET_DASHBOARD_STOCK_AGING_FILE_DATA:
      return Object.assign({}, state, {
        getDashboardStockAgingFileData: payload
      });
    case GET_DASHBOARD_LAND_AQUIRED_ZONE_DATA:
      return Object.assign({}, state, {
        getDashboardLandAquiredZoneData: payload
      });
    case GET_DASHBOARD_LAND_AQUIRED_PROJECT_DATA:
      return Object.assign({}, state, {
        getDashboardLandAquiredProjectData: payload
      });
    case GET_DASHBOARD_LAND_AQUIRED_FILE_DATA:
      return Object.assign({}, state, {
        getDashboardLandAquiredFileData: payload
      });
    case GET_DASHBOARD_APPLAN_APPROVAL_ZONE_DATA:
      return Object.assign({}, state, {
        getDashboardApplanApprovalZoneData: payload
      });
    case GET_DASHBOARD_APPLAN_APPROVAL_PROJECT_DATA:
      return Object.assign({}, state, {
        getDashboardApplanApprovalProjectData: payload
      });
    case GET_DASHBOARD_APPLAN_APPROVAL_FILE_DATA:
      return Object.assign({}, state, {
        getDashboardApplanApprovalFileData: payload
      });
    case GET_DASHBOARD_LAND_AQUIRED_FINANCIAL_YEAR_DATA:
      return Object.assign({}, state, {
        getBDDashboardLandAcquisitionData: payload
      });
    case GET_DASHBOARD_PLAN_APPROVAL_FINANCIAL_YEAR_DATA:
      return Object.assign({}, state, {
        getBDDashboardPlanApprovalData: payload
      });
    case GET_DASHBOARD_PLAN_APPROVED_TARGET_ACTUAL_FINANCIAL_YEAR_DATA:
      return Object.assign({}, state, {
        getBDDashboardPlanApprovedTargetActualData: payload
      });
    case GET_DASHBOARD_DATA_DEPARTMENT:
      return Object.assign({}, state, {
        getBDDashboardDataDepartment: payload
      });
    case GET_DASHBOARD_DEPARTMENT:
      return Object.assign({}, state, { getBDDashboardDepartment: payload });
    case GET_LIAISON_PROCESS_PLAN_REPORT:
      return Object.assign({}, state, { getLiaisonProcessPlanReport: payload });
    case GET_LIAISON_PROCESS_PLAN_REPORT_DETAIL:
      return Object.assign({}, state, {
        liaisonProcessPlanReportDetail: payload
      });
    case GET_MY_DASHBOARD_DATA_FILTER_USER:
      return Object.assign({}, state, {
        getMyDashboardDataFilterUser: payload
      });
    case GET_DASHBOARD_CRM_PROJECT_OUTSTANDING:
      return Object.assign({}, state, {
        getDashboardCrmProjectOutstanding: payload
      });
    case GET_DASHBOARD_CRM_PROJECT_OUTSTANDING_EXPORT:
      return Object.assign({}, state, {
        getDashboardCrmProjectOutstandingExport: payload
      });
    case GET_DASHBOARD_CRM_SITE_OUTSTANDING:
      return Object.assign({}, state, {
        getDashboardCrmSiteOutstanding: payload
      });
    case GET_DASHBOARD_CRM_PROJECT_TARGET:
      return Object.assign({}, state, {
        getDashboardCrmProjectTarget: payload
      });
    case GET_DASHBOEAR_CRM_SITE_TARGET:
      return Object.assign({}, state, { getDashboardCrmSiteTarget: payload });
    case GET_DASHBOARD_CRM_PROJECT_RECEIVED:
      return Object.assign({}, state, {
        getDashboardCrmProjectReceived: payload
      });
    case GET_DASHBOARD_CRM_SITE_RECEIVED:
      return Object.assign({}, state, { getDashboardCrmSiteReceived: payload });
    case GET_DASHBOARD_CRM_PROJECT_REALIZED:
      return Object.assign({}, state, {
        getDashboardCrmProjectRealized: payload
      });
    case GET_DAHSBOARD_CRM_SITE_REALIZED:
      return Object.assign({}, state, { getDashboardCrmSiteRealized: payload });
    case GET_DASHBOARD_CRM_PROJECT_NOT_REALIZED:
      return Object.assign({}, state, {
        getDashboardCrmProjectNotRealized: payload
      });
    case GET_DAHSBOARD_CRM_SITE_NOT_REALIZED:
      return Object.assign({}, state, {
        getDashboardCrmSiteNotRealized: payload
      });
    case GET_DASHBOARD_DATA_PRE_SALES:
      return Object.assign({}, state, { DashboardDataPreSales: payload });
    case GET_DASHBOARD_DATA_MARKETING_FUNNEL:
      return Object.assign({}, state, {
        getDashboardDataMarketingFunnel: payload
      });
    // nikhil
    case GET_GRN_ON_TIME_REPORT:
      return Object.assign({}, state, { getGRNOnTimeKPIReport: payload });

    case GET_GRN_ON_TIME_REPORT_EXPORT:
      return Object.assign({}, state, { getGRNOnTimeKPIReportExport: payload });

    case GET_VENDOR_LEAD_TIME_REPORT:
      return Object.assign({}, state, { getVendorLeadTimeKPIReport: payload });

    case GET_VENDOR_LEAD_TIME_REPORT_EXPORT:
      return Object.assign({}, state, {
        getVendorLeadTimeKPIReportExport: payload
      });

    case GET_STOCK_PROJECT:
      return Object.assign({}, state, { getStockProject: payload });

    case GET_PURCHASE_INVOICE_ON_TIME_KPI:
      return Object.assign({}, state, { getPurchaseInvoiceOnTimeKPI: payload });

    case GET_PURCHASE_INVOICE_ON_TIME_KPI_EXPORT:
      return Object.assign({}, state, {
        getPurchaseInvoiceOnTimeKPIExport: payload
      });

    case GET_PURCHASE_INVOICE_ON_TIME_KPI_REPORT:
      return Object.assign({}, state, {
        getPurchaseInvoiceOnTimeKPIReport: payload
      });

    case GET_PURCHASE_INVOICE_ON_TIME_KPI_REPORT_EXPORT:
      return Object.assign({}, state, {
        getPurchaseInvoiceOnTimeKPIReportExport: payload
      });

    case GET_MATERIAL_QUANTITY_REJECTION_KPI:
      return Object.assign({}, state, {
        getMaterialQuantityRejectionKPI: payload
      });

    case GET_MATERIAL_QUANTITY_REJECTION_KPI_EXPORT:
      return Object.assign({}, state, {
        getMaterialQuantityRejectionKPIExport: payload
      });

    case GET_MATERIAL_QUANTITY_REJECTION_KPI_REPORT:
      return Object.assign({}, state, {
        getMaterialQuantityRejectionKPIReport: payload
      });

    case GET_MATERIAL_QUANTITY_REJECTION_KPI_REPORT_EXPORT:
      return Object.assign({}, state, {
        getMaterialQuantityRejectionKPIReportExport: payload
      });
    case GET_INDENT_PURCHASE_ORDER_KPI_REPORT:
      return Object.assign({}, state, {
        getIndentPurchaseOrderKPIReport: payload
      });

    case GET_INDENT_PURCHASE_ORDER_KPI_REPORT_EXPORT:
      return Object.assign({}, state, {
        getIndentPurchaseOrderKPIReportExport: payload
      });
    case GET_DASHBOARD_DATA_REGISTRATION_TURN_AROUND_TIME:
      return Object.assign({}, state, {
        getDashboardDataRegistrationTurnaroundTime: payload
      });
    case GET_REGISTRATION_TURNAROUND_TIME_REPORT:
      return Object.assign({}, state, {
        getRegistrationTurnaroundTimeReport: payload
      });
    case GET_REGISTRATION_TURNAROUND_TIME_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getRegistrationTurnaroundTimeReportFilterProject: payload
      });
    case GET_REGISTRATION_TURNAROUND_TIME_REPORT_FILTER_USER:
      return Object.assign({}, state, {
        getRegistrationTurnaroundTimeReportFilterUser: payload
      });
    case GET_CIVIL_RESOURCE_REPORT:
      return Object.assign({}, state, { getCivilResourceReport: payload });
    case GET_CIVIL_RESOURCE_REPORT_NON_MATERIAL:
      return Object.assign({}, state, {
        getCivilResourceReportNonMaterial: payload
      });
    case GET_ON_TIME_DELIVERY_KPI:
      return Object.assign({}, state, { getOnTimeDeliveryKPI: payload });
    case GET_ON_TIME_DELIVERY_KPI_EXPORT:
      return Object.assign({}, state, { getOnTimeDeliveryKPIExport: payload });
    case GET_ON_TIME_DELIVERY_KPI_REPORT:
      return Object.assign({}, state, { getOnTimeDeliveryKPIReport: payload });
    case GET_ON_TIME_DELIVERY_KPI_REPORT_EXPORT:
      return Object.assign({}, state, {
        getOnTimeDeliveryKPIReportExport: payload
      });
    case GET_PROCUREMENT_KPI_REPORT:
      return Object.assign({}, state, { getProcurmentKpiReport: payload });
    case GET_SALES_CRM_REPORT:
      return Object.assign({}, state, { getSalesCrmReport: payload });
    case GET_SALES_CRM_REPORT_EXPORT:
      return Object.assign({}, state, { getSalesCrmReportExport: payload });
    case GET_CRM_PROJECTS:
      return Object.assign({}, state, { getCrmProjects: payload });
    case GET_SCALE_TYPE:
      return Object.assign({}, state, { getScaleType: payload });
    case GET_CRM_SITE:
      return Object.assign({}, state, { getCrmSite: payload });
    case GET_CRM_SITE_DIMENSION:
      return Object.assign({}, state, { getCrmSiteDimension: payload });
    case GET_KPI_SALES_REPORT:
      return Object.assign({}, state, { getKpiSalesReport: payload });
    case GET_KPI_SALES_REPORT_EXPORT:
      return Object.assign({}, state, { getKpiSalesReportExport: payload });

    case GET_KPI_SALES_REPORT_EXECUTIVE_FILTER:
      return Object.assign({}, state, {
        getKPISalesReportExecutiveFilter: payload
      });

    case GET_KPI_SALES_REPORT_DETAILS:
      return Object.assign({}, state, { getKPISalesReportDetail: payload });

    case GET_KPI_SALES_REPORT_DETAILS_PROJECT_FILTER:
      return Object.assign({}, state, {
        getKPISalesReportDetailProjectFilter: payload
      });

    case GET_KPI_SALES_REPORT_DETAILS_EXPORT:
      return Object.assign({}, state, {
        getKPISalesReportDetailExport: payload
      });

    case GET_KPI_PRE_SALES_REPORT:
      return Object.assign({}, state, { getKPIPreSalesReport: payload });

    case GET_KPI_PRE_SALES_REPORT_EXPORT:
      return Object.assign({}, state, { getKPIPreSalesReportExport: payload });
    case GET_KPI_PRE_SALES_REPORT_EXECUTIVE_FILTER:
      return Object.assign({}, state, {
        getKPIPreSalesReportExecutiveFilter: payload
      });
    case GET_KPI_SALES_PRE_REPORT_DETAILS:
      return Object.assign({}, state, { getKPIPreSalesReportDetails: payload });
    case GET_KPI_PRE_SALES_REPORT_DETAILS_PROJECT_FILTER:
      return Object.assign({}, state, {
        getKPIPreSalesReportProjectFilter: payload
      });

    case GET_KPI_SALES_PRE_REPORT_DETAILS_EXPORT:
      return Object.assign({}, state, {
        getKPIPreSalesReportDetailsExport: payload
      });

    case GET_KPI_SALES_CRM_REPORT:
      return Object.assign({}, state, { getKPISalesCrmReport: payload });
    case GET_KPI_SALES_CRM_REPORT_EXPORT:
      return Object.assign({}, state, { getKPISalesCrmReportExport: payload });
    case GET_KPI_SALES_CRM_REPORT_PROJECT_FILTER:
      return Object.assign({}, state, {
        getKPISalesCrmReportProjectFilter: payload
      });
    case GET_KPI_SALES_CRM_REPORT_SOURCE_FILTER:
      return Object.assign({}, state, {
        getKPISalesCrmReportSourceFilter: payload
      });

    case GET_KPI_SALES_CRM_REPORT_SALES_EXECUTIVE_FILTER:
      return Object.assign({}, state, {
        getKPISalesCrmReportSalesExecutiveFilter: payload
      });
    case GET_KPI_SALES_REPORT2:
      return Object.assign({}, state, { getKPISalesReport2: payload });
    case GET_KPI_SALES_REPORT2_EXPORT:
      return Object.assign({}, state, { getKPISalesReport2Export: payload });
    case GET_KPI_SALES_SUMMARY_REPORT:
      return Object.assign({}, state, { getKPISalesSummaryReport: payload });
    case GET_KPI_SALES_SUMMARY_REPORT_EXPORT:
      return Object.assign({}, state, {
        getKPISalesSummaryReportExport: payload
      });
    case GET_KPI_SALES_SUMMARY_REPORT_DETAILS:
      return Object.assign({}, state, {
        getKPISalesSummaryReportDetail: payload
      });
    case GET_KPI_SALES_SUMMARY_REPORT_DETAILS_EXPORT:
      return Object.assign({}, state, {
        getKPISalesSummaryReportDetailExport: payload
      });
    case GET_KPI_TELECALLING_REPORT:
      return Object.assign({}, state, {
        getKPITelecallingReport: payload
      });
    case GET_KPI_TELECALLING_REPORT_EXPORT:
      return Object.assign({}, state, {
        getKPITelecallingReportExport: payload
      });

    case GET_KPI_SALES_REPORT_LEAD_ASSIGNED_DETAIL:
      return Object.assign({}, state, {
        getKPIPreSalesReportLeadAssignedDetail: payload
      });
    case GET_KPI_SALES_REPORT_LEAD_ASSIGNED_DETAIL_EXPORT:
      return Object.assign({}, state, {
        getKPIPreSalesReportLeadAssignedDetailExport: payload
      });

    case GET_KPI_SALES_REPORT_SITE_VISIT_DETAIL:
      return Object.assign({}, state, {
        getKPISalesReportSiteVisitDetail: payload
      });

    case GET_KPI_SALES_REPORT_CRM_BOOKING_DETAILS:
      return Object.assign({}, state, {
        getKPISalesReportCrmBookingDetail: payload
      });
    case GET_KPI_SALES_REPORT_CRM_BOOKING_DETAILS_EXPORT:
      return Object.assign({}, state, {
        getKPISalesReportCrmBookingDetailExport: payload
      });
    case GET_KPI_SALES_REPORT_CRM_CANCELLATION_DETAILS:
      return Object.assign({}, state, {
        getKPISalesReportCrmCancellationDetail: payload
      });
    case GET_CAMPAIGN_REPORT:
      return Object.assign({}, state, {
        getCampaignReport: payload
      });
    case GET_CAMPAIGN_REPORT_EXPORT:
      return Object.assign({}, state, {
        getCampaignReportExport: payload
      });
    case GET_CAMPAIGN_REPORT_FILTER_CAMPAIGN:
      return Object.assign({}, state, {
        getCampaignReportFilterCampaign: payload
      });
    case GET_KPI_SALES_REPORT_SITE_VISIT_DETAILS_EXPORT:
      return Object.assign({}, state, {
        getKPISalesReportSiteVisitDetailExport: payload
      });
    case GET_CAMPAIGN_PROJECT_REPORT:
      return Object.assign({}, state, {
        getCampaignProjectReport: payload
      });
    case GET_CAMPAIGN_PROJECT_REPORT_EXPORT:
      return Object.assign({}, state, {
        getCampaignProjectReportExport: payload
      });
    case GET_CAMPAIGN_PROJECT_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getCampaignProjectReportFilterProject: payload
      });
    case GET_CAMPAIGN_ENQUIRY_REPORT:
      return Object.assign({}, state, {
        getCampaignEnquiryReport: payload
      });
    case GET_CAMPAIGN_ENQUIRY_REPORT_EXPORT:
      return Object.assign({}, state, {
        getCampaignEnquiryReportExport: payload
      });
    case GET_CAMPAIGN_BOOKING_REPORT:
      return Object.assign({}, state, {
        getCampaignBookingReport: payload
      });
    case GET_CAMPAIGN_BOOKING_REPORT_EXPORT:
      return Object.assign({}, state, {
        getCampaignBookingReportExport: payload
      });
    case GET_CAMPAIGN_BOOKING_CANCELLED_REPORT:
      return Object.assign({}, state, {
        getCampaignBookingCancelledReport: payload
      });
    case GET_CAMPAIGN_BOOKING_CANCELLED_REPORT_EXPORT:
      return Object.assign({}, state, {
        getCampaignBookingCancelledReportExport: payload
      });
    case GET_CAMPAIGN_SITE_VISIT_REPORT:
      return Object.assign({}, state, {
        getCampaignSiteVisitReport: payload
      });
    case GET_CAMPAIGN_SITE_VISIT_REPORT_EXPORT:
      return Object.assign({}, state, {
        getCampaignSiteVisitReportExport: payload
      });
    case GET_FINANCIAL_YEAR:
      return Object.assign({}, state, {
        getFinancialYear: payload
      });
    case GET_FINANCIAL_YEAR_SCALE_TYPE:
      return Object.assign({}, state, {
        getFinancialYearScaleType: payload
      });
    case GET_FINANCIAL_YEAR_SCALE_VALUE:
      return Object.assign({}, state, {
        getFinancialYearScaleValue: payload
      });
    case GET_KPI_SALES_REPORT_CRM_CANCELLATION_DETAILS_EXPORT:
      return Object.assign({}, state, {
        getKPISalesReportCrmCancellationDetailExport: payload
      });

    case GET_PRE_SALES_SITE_VISIT:
      return Object.assign({}, state, {
        getKPIPreSalesSiteVisit: payload
      });

    case GET_PRE_SALES_SITE_VISIT_EXPORT:
      return Object.assign({}, state, {
        getKPIPreSalesSiteVisitExport: payload
      });

    case GET_KPITELECALLING_FILTER_USER:
      return Object.assign({}, state, { getKPITelecallingFilterUser: payload });

    case GET_KPI_SALES_SUMMARY_FILTER_USER:
      return Object.assign({}, state, {
        getKPISalesSummaryFilterUser: payload
      });
    // case DISPLAY_MESSAGE:
    //     return Object.assign({}, state, { messageInfo: payload });

    // case DISPLAY_ERROR:
    //     return Object.assign({}, state, { error: payload.error });

    // case SUCCESS_STATUS:
    //     return Object.assign({}, state, { status: payload.status });

    // case OTP_SENT_SUCCESS:
    //     return Object.assign({}, state, { otp_sent: true });

    // case OTP_VALID_FAILS:
    //     return Object.assign({}, state, { valid_otp: false });

    // case OTP_VALID_SUCCESS:
    //         return Object.assign({}, state, { valid_otp: true });
    case GET_SALES_REPORT:
      return Object.assign({}, state, { getSalesReport: payload });
    case GET_SALES_REPORT_EXPORT:
      return Object.assign({}, state, { getSalesReportExport: payload });
    case GET_SALES_REPORT_AGREEMENT:
      return Object.assign({}, state, {
        getSalesReportAgreement: payload
      });
    case GET_SALES_REPORT_AGREEMENT_EXPORT:
      return Object.assign({}, state, {
        getSalesReportAgreementExport: payload
      });

    case GET_SALES_REPORT_REGISTRATION:
      return Object.assign({}, state, {
        getSalesReportRegistration: payload
      });

    case GET_SALES_REPORT_REGISTRATION_EXPORT:
      return Object.assign({}, state, {
        getSalesReportRegistrationExport: payload
      });
    case GET_SALES_REPORT_SITE_VISIT:
      return Object.assign({}, state, { getSalesReportSiteVisit: payload });
    case GET_SALES_REPORT_SITE_VISIT_FILTER_STM:
      return Object.assign({}, state, {
        getSalesReportSiteVisitFilterStm: payload
      });
    case GET_SALES_REPORT_BOOKING_FILTER_STM:
      return Object.assign({}, state, {
        getSalesReportBookingFilterStm: payload
      });
    case GET_SALES_REPORT_FOLLOW_UP_FILTER_STM:
      return Object.assign({}, state, {
        getSalesReportFollowUpFilterStm: payload
      });
    case GET_SALES_REPORT_SITE_VISIT_EXPORT:
      return Object.assign({}, state, {
        getSalesReportSiteVisitExport: payload
      });
    case GET_SALES_REPORT_FOLLOW_UP:
      return Object.assign({}, state, { getSalesReportFollowUp: payload });
    case GET_SALES_REPORT_FOLLOW_UP_EXPORT:
      return Object.assign({}, state, {
        getSalesReportFollowUpExport: payload
      });
    case GET_SALES_REPORT_PROSPECTIVE_CLIENT:
      return Object.assign({}, state, {
        getSalesReportProspectiveClient: payload
      });
    case GET_SALES_REPORT_PROSPECTIVE_CLIENT_EXPORT:
      return Object.assign({}, state, {
        getSalesReportProspectiveClientExport: payload
      });
    case GET_SALES_REPORT_BOOKING:
      return Object.assign({}, state, { getSalesReportBooking: payload });
    case GET_SALES_REPORT_BOOKING_EXPORT:
      return Object.assign({}, state, { getSalesReportBookingExport: payload });
    case GET_SALES_REPORT_CANCELLATION:
      return Object.assign({}, state, { getSalesReportCancellation: payload });
    case GET_SALES_REPORT_CANCELLATION_EXPORT:
      return Object.assign({}, state, {
        getSalesReportCancellationExport: payload
      });
    case GET_SALES_REPORT_HOT_PROSPECTIVE_CLIENT:
      return Object.assign({}, state, {
        getSalesReportHotProspectiveClient: payload
      });
    case GET_SALES_REPORT_HOT_PROSPECTIVE_CLIENT_EXPORT:
      return Object.assign({}, state, {
        getSalesReportHotProspectiveClientExport: payload
      });
    case GET_MONTH_WEEK:
      return Object.assign({}, state, { getMonthWeek: payload });
    case GET_SALES_REPORT_PLANNED_CP_MEETING:
      return Object.assign({}, state, {
        getSalesReportPlannedCpMeeting: payload
      });
    case GET_SALES_REPORT_PLANNED_CP_MEETING_EXPORT:
      return Object.assign({}, state, {
        getSalesReportPlannedCpMeetingExport: payload
      });
    case GET_SALES_REPORT_CLIENT_MEETING:
      return Object.assign({}, state, { getSalesReportClientMeeting: payload });
    case GET_SALES_REPORT_CLIENT_MEETING_EXPORT:
      return Object.assign({}, state, {
        getSalesReportClientMeetingExport: payload
      });
    case GET_SALES_REPORT_TEAM:
      return Object.assign({}, state, {
        getSalesReportTeam: payload
      });
    case GET_SALES_REPORT_TEAM_EXPORT:
      return Object.assign({}, state, {
        getSalesReportTeamExport: payload
      });
    case GET_SALES_REPORT_FILTER_TEAM:
      return Object.assign({}, state, {
        getSalesReportFilterTeam: payload
      });
    case GET_SALES_REPORT_FILTER_USER:
      return Object.assign({}, state, {
        getSalesReportFilterUser: payload
      });
    case GET_SALES_REPORT_PLANNED_FOLLOW_UP:
      return Object.assign({}, state, {
        getSalesReportPlannedFollowUp: payload
      });
    case GET_SALES_REPORT_PLANNED_FOLLOW_UP_EXPORT:
      return Object.assign({}, state, {
        getSalesReportPlannedFollowUpExport: payload
      });
    case GET_SALES_REPORT_PLANNED_SITE_VISIT:
      return Object.assign({}, state, {
        getSalesReportPlannedSiteVisit: payload
      });
    case GET_SALES_REPORT_PLANNED_SITE_VISIT_EXPORT:
      return Object.assign({}, state, {
        getSalesReportPlannedSiteVisitExport: payload
      });
    case GET_KPI_SALES_REPORT_CRM_BOOKING_DETAIL_FILTER_PROJECT:
      return Object.assign({}, state, {
        getKPISalesReportCrmBookingDetailFilterProject: payload
      });
    case GET_KPI_SALES_REPORT_CRM_CANCELLATION_DETAIL_FILTER_PROJECT:
      return Object.assign({}, state, {
        getKPISalesReportCrmCancellationDetailFilterProject: payload
      });
    case GET_KPI_SALES_REPORT_SITE_VISIT_DETAIL_FILTER_PROJECT:
      return Object.assign({}, state, {
        getKPISalesReportSiteVisitDetailFilterProject: payload
      });
    case GET_SALES_REPORT_COMPLETED_CP_MEETING:
      return Object.assign({}, state, {
        getSalesReportCompletedCpMeeting: payload
      });

    case GET_SALES_REPORT_COMPLETED_CP_MEETING_EXPORT:
      return Object.assign({}, state, {
        getSalesReportCompletedCpMeetingExport: payload
      });
    case GET_SALES_REPORT_PLANNED_CLIENT_MEETING:
      return Object.assign({}, state, {
        getSalesReportPlannedClientMeeting: payload
      });
    case GET_SALES_REPORT_PLANNED_CLIENT_MEETING_EXPORT:
      return Object.assign({}, state, {
        getSalesReportPlannedClientMeetingExport: payload
      });
    case GET_SALES_REPORT_COMPLETED_CLIENT_MEETING:
      return Object.assign({}, state, {
        getSalesReportCompletedClientMeeting: payload
      });
    case GET_SALES_REPORT_COMPLETED_CLIENT_MEETING_EXPORT:
      return Object.assign({}, state, {
        getSalesReportCompletedClientMeetingExport: payload
      });
    case GET_SALES_REPORT_ENQUIRY_FOLLOW_UP:
      return Object.assign({}, state, {
        getSalesReportEnquiryFollowUp: payload
      });
    case GET_SALES_REPORT_ENQUIRY_FOLLOW_UP_EXPORT:
      return Object.assign({}, state, {
        getSalesReportEnquiryFollowUpExport: payload
      });
    //cp sales report
    case GET_SALES_CHANNEL_PARTNER_REPORT:
      return Object.assign({}, state, {
        getSalesChannelPartnerReport: payload
      });
    case GET_SALES_CHANNEL_PARTNER_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSalesChannelPartnerReportExport: payload
      });
    case GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT:
      return Object.assign({}, state, {
        getSalesChannelPartnerProjectReport: payload
      });
    case GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSalesChannelPartnerProjectReportExport: payload
      });
    case GET_SALES_CHANNEL_PARTNER_ENQUIRY_REPORT:
      return Object.assign({}, state, {
        getSalesChannelPartnerEnquiryReport: payload
      });
    case GET_SALES_CHANNEL_PARTNER_ENQUIRY_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSalesChannelPartnerEnquiryReportExport: payload
      });
    case GET_SALES_CHANNEL_PARTNER_SITE_VISIT_REPORT:
      return Object.assign({}, state, {
        getSalesChannelPartnerSiteVisitReport: payload
      });
    case GET_SALES_CHANNEL_PARTNER_SITE_VISIT_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSalesChannelPartnerSiteVisitReportExport: payload
      });
    case GET_SALES_CHANNEL_PARTNER_BOOKING_REPORT:
      return Object.assign({}, state, {
        getSalesChannelPartnerBookingReport: payload
      });
    case GET_SALES_CHANNEL_PARTNER_BOOKING_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSalesChannelPartnerBookingReportExport: payload
      });
    case GET_SALES_CHANNEL_PARTNER_CANCELLATION_REPORT:
      return Object.assign({}, state, {
        getSalesChannelPartnerCancellationReport: payload
      });
    case GET_SALES_CHANNEL_PARTNER_CANCELLATION_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSalesChannelPartnerCancellationReportExport: payload
      });
    case GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesChannelPartnerProjectReportFilterProject: payload
      });
    case GET_SALES_CHANNEL_PARTNER_ENQUIRY_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesChannelPartnerEnquiryReportFilterProject: payload
      });
    case GET_SALES_CHANNEL_PARTNER_SITE_VISIT_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesChannelPartnerSiteVisitReportFilterProject: payload
      });
    case GET_SALES_CHANNEL_PARTNER_BOOKING_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesChannelPartnerBookingReportFilterProject: payload
      });
    case GET_SALES_CHANNEL_PARTNER_CANCELLATION_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesChannelPartnerCancellationReportFilterProject: payload
      });
    //source sales report
    case GET_SALES_SOURCE_REPORT:
      return Object.assign({}, state, {
        getSalesSourceReport: payload
      });
    case GET_SALES_SOURCE_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSalesSourceReportExport: payload
      });
    case GET_SALES_SOURCE_PROJECT_REPORT:
      return Object.assign({}, state, {
        getSalesSourceProjectReport: payload
      });
    case GET_SALES_SOURCE_PROJECT_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSalesSourceProjectReportExport: payload
      });
    case GET_SALES_SOURCE_ENQUIRY_REPORT:
      return Object.assign({}, state, {
        getSalesSourceEnquiryReport: payload
      });
    case GET_SALES_SOURCE_ENQUIRY_REPORT_FILTER_SOURCE:
      return Object.assign({}, state, {
        getSalesSourceEnquiryReportFilterSource: payload
      });
    case GET_SALES_SOURCE_SITE_VISIT_REPORT_FILTER_SOURCE:
      return Object.assign({}, state, {
        getSalesSourceSiteVisitReportFilterSource: payload
      });
    case GET_SALES_SOURCE_BOOKING_REPORT_FILTER_SOURCE:
      return Object.assign({}, state, {
        getSalesSourceBookingReportFilterSource: payload
      });
    case GET_SALES_SOURCE_CANCELLATION_REPORT_FILTER_SOURCE:
      return Object.assign({}, state, {
        getSalesSourceCancellationReportFilterSource: payload
      });
    case GET_SALES_SOURCE_ENQUIRY_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSalesSourceEnquiryReportExport: payload
      });
    case GET_SALES_SOURCE_SITE_VISIT_REPORT:
      return Object.assign({}, state, {
        getSalesSourceSiteVisitReport: payload
      });
    case GET_SALES_SOURCE_SITE_VISIT_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSalesSourceSiteVisitReportExport: payload
      });
    case GET_SALES_SOURCE_BOOKING_REPORT:
      return Object.assign({}, state, {
        getSalesSourceBookingReport: payload
      });
    case GET_SALES_SOURCE_BOOKING_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSalesSourceBookingReportExport: payload
      });
    case GET_SALES_SOURCE_CANCELLATION_REPORT:
      return Object.assign({}, state, {
        getSalesSourceCancellationReport: payload
      });
    case GET_SALES_SOURCE_CANCELLATION_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSalesSourceCancellationReportExport: payload
      });
    case GET_SALES_SOURCE_PROJECT_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesSourceProjectReportFilterProject: payload
      });
    case GET_SALES_SOURCE_ENQUIRY_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesSourceEnquiryReportFilterProject: payload
      });
    case GET_SALES_SOURCE_SITE_VISIT_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesSourceSiteVisitReportFilterProject: payload
      });
    case GET_SALES_SOURCE_BOOKING_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesSourceBookingReportFilterProject: payload
      });
    case GET_SALES_SOURCE_CANCELLATION_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesSourceCancellationReportFilterProject: payload
      });
    case GET_ENQUIRY_SOURCE_CATEGORY:
      return Object.assign({}, state, {
        getEnquirySourceCategory: payload
      });
    case GET_ENQUIRY_SOURCE_FILTER:
      return Object.assign({}, state, {
        getEnquirySourceFilter: payload
      });
    case GET_SALES_CHANNEL_PARTNER_PROJECT_REPORT_FILTER_CHANNEL_PARTNER:
      return Object.assign({}, state, {
        getSalesChannelPartnerProjectReportFilterChannelPartner: payload
      });
    case GET_SALES_CHANNEL_PARTNER_ON_BOARD_REPORT:
      return Object.assign({}, state, {
        getSalesChannelPartnerOnBoardReport: payload
      });
    case GET_SALES_CHANNEL_PARTNER_ON_BOARD_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSalesChannelPartnerOnBoardReportExport: payload
      });
    case GET_SALES_CHANNEL_PARTNER_REPORT_FILTER_SALES_EXECUTIVE:
      return Object.assign({}, state, {
        getSalesChannelPartnerReportFilterSalesExecutive: payload
      });
    case GET_PRE_SALES_REPORT:
      return Object.assign({}, state, {
        getPreSalesReport: payload
      });
    case GET_PRE_SALES_REPORT_FILTER_EXECUTIVE:
      return Object.assign({}, state, {
        getPreSalesReportFilterExecutive: payload
      });
    case GET_PRE_SALES_REPORT_FILTER_SOURCE_CATEGORY:
      return Object.assign({}, state, {
        getPreSalesReportFilterSourceCategory: payload
      });
    case GET_PRE_SALES_REPORT_FILTER_SOURCE:
      return Object.assign({}, state, {
        getPreSalesReportFilterSource: payload
      });

    case GET_PRE_SALES_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getPreSalesReportFilterProject: payload
      });
    case GET_PRE_SALES_REPORT_EXPORT:
      return Object.assign({}, state, {
        getPreSalesReportExport: payload
      });
    case GET_PRE_SALES_ENQUIRY_REPORT:
      return Object.assign({}, state, {
        getPreSalesEnquiryReport: payload
      });

    case GET_PRE_SALES_PROJECT_REPORT:
      return Object.assign({}, state, {
        getPreSalesProjectReport: payload
      });
    case GET_PRE_SALES_REPORT_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getPreSalesReportFilterDepartment: payload
      });
    case GET_PRE_SALES_PROJECT_REPORT_EXPORT:
      return Object.assign({}, state, {
        getPreSalesProjectReportExport: payload
      });
    case GET_PRE_SALES_PROJECT_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getPreSalesProjectReportFilterProject: payload
      });
    case GET_PRE_SALES_ENQUIRY_REPORT_EXPORT:
      return Object.assign({}, state, {
        getPreSalesEnquiryReportExport: payload
      });
    case GET_PRE_SALES_ENQUIRY_OVER_DUE_REPORT:
      return Object.assign({}, state, {
        getPreSalesEnquiryOverdueReport: payload
      });

    case GET_PRE_SALES_ENQUIRY_OVER_DUE_REPORT_EXPORT:
      return Object.assign({}, state, {
        getPreSalesEnquiryOverdueReportExport: payload
      });
    case GET_SALES_REPORT_CANCELLATION_PREVIOUS:
      return Object.assign({}, state, {
        getSalesReportCancellationPrevious: payload
      });
    case GET_SALES_REPORT_CANCELLATION_PREVIOUS_EXPORT:
      return Object.assign({}, state, {
        getSalesReportCancellationPreviousExport: payload
      });
    case GET_SALES_REPORT_BOOKING_GROSS:
      return Object.assign({}, state, {
        getSalesReportBookingGross: payload
      });
    case GET_SALES_REPORT_BOOKING_GROSS_EXPORT:
      return Object.assign({}, state, {
        getSalesReportBookingGrossExport: payload
      });
    //My Dashboard
    case GET_PENDING_DASHBOARD_DATA:
      return Object.assign({}, state, {
        getPendingDashboardData: payload
      });
    case GET_PENDING_ACCOUNTABLE_DASHBOARD_DATA:
      return Object.assign({}, state, {
        getPendingAccountableDashboardData: payload
      });
    case GET_DASHBOARD_DEPARTMENT_DATA:
      return Object.assign({}, state, {
        getDashboardDepartmentData: payload
      });
    case GET_PENDING_RESPONSIBLE_DASHBOARD_DATA:
      return Object.assign({}, state, {
        getPendingResponsibleDashboardData: payload
      });
    //Liasion Process
    case GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN:
      return Object.assign({}, state, {
        getDashboardDataLiaisonProcessPlan: payload
      });
    case GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataLiaisonProcessPlanExport: payload
      });
    case GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataLiaisonProcessPlanFilterProject: payload
      });
    case GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_PROCESS:
      return Object.assign({}, state, {
        getDashboardDataLiaisonProcessPlanFilterProcess: payload
      });
    case GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_ACCOUNTABLE:
      return Object.assign({}, state, {
        getDashboardDataLiaisonProcessPlanFilterAccountable: payload
      });
    case GET_DASHBOARD_DATA_LIAISON_PROCESS_PLAN_FILTER_RESPONSIBLE:
      return Object.assign({}, state, {
        getDashboardDataLiaisonProcessPlanFilterResponsible: payload
      });
    //Liasion Documenetation
    case GET_DASHBOARD_DATA_DOCUMENTATION_PLAN:
      return Object.assign({}, state, {
        getDashboardDataDocumentationPlan: payload
      });
    case GET_DASHBOARD_DATA_DOCUMENTATION_PLAN_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataDocumentationPlanExport: payload
      });
    case GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataLiaisonDocumentationFilterProject: payload
      });
    case GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getDashboardDataLiaisonDocumentationFilterCategory: payload
      });
    case GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_ACCOUNTABLE:
      return Object.assign({}, state, {
        getDashboardDataLiaisonDocumentationFilterAccountable: payload
      });
    case GET_DASHBOARD_DATA_LIAISON_DOCUMENTATION_FILTER_RESPONSIBLE:
      return Object.assign({}, state, {
        getDashboardDataLiaisonDocumentationFilterResponsible: payload
      });
    //APF Query
    case GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY:
      return Object.assign({}, state, {
        getDashboardDataApfTaskPlanQuery: payload
      });
    case GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataApfTaskPlanQueryExport: payload
      });
    case GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_FILTER_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataApfTaskPlanQueryFilterProject: payload
      });
    case GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_FILTER_ACCOUNTABLE:
      return Object.assign({}, state, {
        getDashboardDataApfTaskPlanQueryFilterAccountable: payload
      });
    case GET_DASHBOARD_DATA_APF_TASK_PLAN_QUERY_FILTER_RESPONSIBLE:
      return Object.assign({}, state, {
        getDashboardDataApfTaskPlanQueryFilterResponsible: payload
      });
    //Loan Query
    case GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY:
      return Object.assign({}, state, {
        getDashboardDataLoanProcessPlanQuery: payload
      });
    case GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataLoanProcessPlanQueryExport: payload
      });
    case GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataLoanProcessPlanQueryFilterProject: payload
      });
    case GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_PROCESS:
      return Object.assign({}, state, {
        getDashboardDataLoanProcessPlanQueryFilterProcess: payload
      });
    case GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_ACCOUNTABLE:
      return Object.assign({}, state, {
        getDashboardDataLoanProcessPlanQueryFilterAccountable: payload
      });
    case GET_DASHBOARD_DATA_LOAN_PROCESS_PLAN_QUERY_FILTER_RESPONSIBLE:
      return Object.assign({}, state, {
        getDashboardDataLoanProcessPlanQueryFilterResponsible: payload
      });
    //Legal Task
    case GET_DASHBOARD_DATA_BD_LEGAL_TASK:
      return Object.assign({}, state, {
        getDashboardDataBdLegalTask: payload
      });
    case GET_DASHBOARD_DATA_BD_LEGAL_TASK_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataBdLegalTaskExport: payload
      });
    case GET_DASHBOARD_DATA_BD_LEGAL_TASK_FILTER_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataBdLegalTaskFilterProject: payload
      });
    case GET_DASHBOARD_DATA_BD_LEGAL_TASK_FILTER_ACCOUNTABLE:
      return Object.assign({}, state, {
        getDashboardDataBdLegalTaskFilterAccountable: payload
      });
    case GET_DASHBOARD_DATA_BD_LEGAL_TASK_FILTER_RESPONSIBLE:
      return Object.assign({}, state, {
        getDashboardDataBdLegalTaskFilterResponsible: payload
      });
    //Boundary Dispute
    case GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE:
      return Object.assign({}, state, {
        getDashboardDataBdLegalTaskDispute: payload
      });
    case GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataBdLegalTaskDisputeExport: payload
      });
    case GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_FILTER_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataBdLegalTaskDisputeFilterProject: payload
      });
    case GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_FILTER_ACCOUNTABLE:
      return Object.assign({}, state, {
        getDashboardDataBdLegalTaskDisputeFilterAccountable: payload
      });
    case GET_DASHBOARD_DATA_BD_LEGAL_TASK_DISPUTE_FILTER_RESPONSIBLE:
      return Object.assign({}, state, {
        getDashboardDataBdLegalTaskDisputeFilterResponsible: payload
      });
    //To Be Acquired
    case GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING:
      return Object.assign({}, state, {
        getDashboardDataProjectFileAcquisitionPending: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataProjectFileAcquisitionPendingExport: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_FILTER_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataProjectFileAcquisitionPendingFilterProject: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_FILTER_ACCOUNTABLE:
      return Object.assign({}, state, {
        getDashboardDataProjectFileAcquisitionPendingFilterAccountable: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_FILE_ACQUISITION_PENDING_FILTER_RESPONSIBLE:
      return Object.assign({}, state, {
        getDashboardDataProjectFileAcquisitionPendingFilterResponsible: payload
      });
    //Court Case
    case GET_DASHBOARD_DATA_COURT_CASE:
      return Object.assign({}, state, {
        getDashboardDataCourtCase: payload
      });
    case GET_DASHBOARD_DATA_COURT_CASE_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataCourtCaseExport: payload
      });
    case GET_DASHBOARD_DATA_COURT_CASE_FILTER_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataCourtCaseFilterProject: payload
      });
    case GET_DASHBOARD_DATA_COURT_CASE_FILTER_ACCOUNTABLE:
      return Object.assign({}, state, {
        getDashboardDataCourtCaseFilterAccountable: payload
      });
    case GET_DASHBOARD_DATA_COURT_CASE_FILTER_RESPONSIBLE:
      return Object.assign({}, state, {
        getDashboardDataCourtCaseFilterResponsible: payload
      });
    //Project Task
    case GET_DASHBOARD_DATA_PROJECT_TASK_PLAN:
      return Object.assign({}, state, {
        getDashboardDataProjectTaskPlan: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataProjectTaskPlanExport: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataProjectTaskPlanFilterProject: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_TASK:
      return Object.assign({}, state, {
        getDashboardDataProjectTaskPlanFilterTask: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_ACCOUNTABLE:
      return Object.assign({}, state, {
        getDashboardDataProjectTaskPlanFilterAccountable: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_TASK_PLAN_FILTER_RESPONSIBLE:
      return Object.assign({}, state, {
        getDashboardDataProjectTaskPlanFilterResponsible: payload
      });
    //To Do
    case GET_DASHBOARD_DATA_TODO:
      return Object.assign({}, state, {
        getDashboardDataToDo: payload
      });
    case GET_DASHBOARD_DATA_TODO_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataToDoExport: payload
      });
    case GET_DASHBOARD_DATA_TODO_FILTER_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataToDoFilterProject: payload
      });
    case GET_DASHBOARD_DATA_TODO_FILTER_ACCOUNTABLE:
      return Object.assign({}, state, {
        getDashboardDataToDoFilterAccountable: payload
      });
    case GET_DASHBOARD_DATA_TODO_FILTER_RESPONSIBLE:
      return Object.assign({}, state, {
        getDashboardDataToDoFilterResponsible: payload
      });

    //Survey
    case GET_DASHBOARD_DATA_PROJECT_SURVEY:
      return Object.assign({}, state, {
        getDashboardDataProjectSurvey: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_SURVEY_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataProjectSurveyExport: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataProjectSurveyFilterProject: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_TASK:
      return Object.assign({}, state, {
        getDashboardDataProjectSurveyFilterTask: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_ACCOUNTABLE:
      return Object.assign({}, state, {
        getDashboardDataProjectSurveyFilterAccountable: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_SURVEY_FILTER_RESPONSIBLE:
      return Object.assign({}, state, {
        getDashboardDataProjectSurveyFilterResponsible: payload
      });

    //Project Legal
    case GET_DASHBOARD_DATA_PROJECT_LEGAL:
      return Object.assign({}, state, {
        getDashboardDataProjectLegal: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_LEGAL_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataProjectLegalExport: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataProjectLegalFilterProject: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_TASK:
      return Object.assign({}, state, {
        getDashboardDataProjectLegalFilterTask: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_ACCOUNTABLE:
      return Object.assign({}, state, {
        getDashboardDataProjectLegalFilterAccountable: payload
      });
    case GET_DASHBOARD_DATA_PROJECT_LEGAL_FILTER_RESPONSIBLE:
      return Object.assign({}, state, {
        getDashboardDataProjectLegalFilterResponsible: payload
      });

    //Makerting
    //Enquiry Generated
    case GET_DASHBOARD_DATA_ENQUIRY:
      return Object.assign({}, state, {
        getDashboardDataEnquiry: payload
      });
    case GET_DASHBOARD_DATA_ENQUIRY_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataEnquiryExport: payload
      });
    case GET_DASHBOARD_DATA_ENQUIRY_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataEnquiryProject: payload
      });
    case GET_DASHBOARD_DATA_ENQUIRY_SOURCE:
      return Object.assign({}, state, {
        getDashboardDataEnquirySource: payload
      });

    //Enquiry Qualificated
    case GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED:
      return Object.assign({}, state, {
        getDashboardDataEnquiry: payload
      });
    case GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataEnquiryExport: payload
      });
    case GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataEnquiryProject: payload
      });
    case GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_SOURCE:
      return Object.assign({}, state, {
        getDashboardDataEnquirySource: payload
      });
    case GET_DASHBOARD_DATA_ENQUIRY_QUALIFIED_PRE_SALES:
      return Object.assign({}, state, {
        getDashboardDataEnquirySource: payload
      });

    //Pre-Sales
    //Site Visit
    case GET_DASHBOARD_DATA_SITE_VISIT:
      return Object.assign({}, state, {
        getDashboardDataSiteVisit: payload
      });
    case GET_DASHBOARD_DATA_SITE_VISIT_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataSiteVisitExport: payload
      });
    case GET_DASHBOARD_DATA_SITE_VISIT_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataSiteVisitProject: payload
      });
    case GET_DASHBOARD_DATA_SITE_VISIT_SOURCE:
      return Object.assign({}, state, {
        getDashboardDataSiteVisitSource: payload
      });
    case GET_DASHBOARD_DATA_SITE_VISIT_STM:
      return Object.assign({}, state, {
        getDashboardDataSiteVisitStm: payload
      });
    case GET_DASHBOARD_DATA_SITE_VISIT_PRE_SALES:
      return Object.assign({}, state, {
        getDashboardDataSiteVisitSourcePreSales: payload
      });

    //Sales
    //Sales
    case GET_DASHBOARD_DATA_SALES_BOOKING:
      return Object.assign({}, state, {
        getDashboardDataSalesBooking: payload
      });
    case GET_DASHBOARD_DATA_SALES_BOOKING_EXPORT:
      return Object.assign({}, state, {
        getDashboardDataSalesBookingExport: payload
      });
    case GET_DASHBOARD_DATA_SALES_BOOKIG_FILTER_PROJECT:
      return Object.assign({}, state, {
        getDashboardDataSalesBookingFilterProject: payload
      });
    case GET_DASHBOARD_DATA_SALES_SOURCE:
      return Object.assign({}, state, {
        getDashboardDataSalesSource: payload
      });
    case GET_DASHBOARD_DATA_SALES_BOOKIG_FILTER_BOOKEDBY:
      return Object.assign({}, state, {
        getDashboardDataSalesBookingFilterBookedBy: payload
      });

    //Cancellation
    case GET_DASHBOARD_DATA_CANCELLATION:
      return Object.assign({}, state, {
        getDashboardCancellation: payload
      });
    case GET_DASHBOARD_DATA_CANCELLATION_EXPORT:
      return Object.assign({}, state, {
        getDashboardCancellationExport: payload
      });
    case GET_DASHBOARD_DATA_CANCELLATION_PROJECT:
      return Object.assign({}, state, {
        getDashboardCancellationProject: payload
      });
    case GET_DASHBOARD_DATA_CANCELLATION_SOURCE:
      return Object.assign({}, state, {
        getDashboardCancellationSource: payload
      });
    case GET_DASHBOARD_DATA_CANCELLATION_STM:
      return Object.assign({}, state, {
        getDashboardCancellationStm: payload
      });

    //CRM
    //Collection
    case GET_DASHBOARD_DATA_COLLECTION:
      return Object.assign({}, state, {
        getDashboardCollection: payload
      });
    case GET_DASHBOARD_DATA_COLLECTION_EXPORT:
      return Object.assign({}, state, {
        getDashboardCollectionExport: payload
      });
    case GET_DASHBOARD_DATA_COLLECTION_PROJECT:
      return Object.assign({}, state, {
        getDashboardCollectionProject: payload
      });
    case GET_DASHBOARD_DATA_COLLECTION_USER:
      return Object.assign({}, state, {
        getDashboardCollectionUser: payload
      });

    //Agreement
    case GET_DASHBOARD_DATA_AGREEMENT:
      return Object.assign({}, state, {
        getDashboardAgreement: payload
      });
    case GET_DASHBOARD_DATA_AGREEMENT_EXPORT:
      return Object.assign({}, state, {
        getDashboardAgreementExport: payload
      });
    case GET_DASHBOARD_DATA_AGREEMENT_PROJECT:
      return Object.assign({}, state, {
        getDashboardAgreementProject: payload
      });
    case GET_DASHBOARD_DATA_AGREEMENT_USER:
      return Object.assign({}, state, {
        getDashboardAgreementUser: payload
      });

    //Registration
    case GET_DASHBOARD_DATA_REGISTRATION:
      return Object.assign({}, state, {
        getDashboardRegistration: payload
      });
    case GET_DASHBOARD_DATA_REGISTRATION_EXPORT:
      return Object.assign({}, state, {
        getDashboardRegistrationExport: payload
      });
    case GET_DASHBOARD_DATA_REGISTRATION_PROJECT:
      return Object.assign({}, state, {
        getDashboardRegistrationProject: payload
      });
    case GET_DASHBOARD_DATA_REGISTRATION_USER:
      return Object.assign({}, state, {
        getDashboardRegistrationUser: payload
      });

    case GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP:
      return Object.assign({}, state, {
        getPreSalesReportPlannedFollowUp: payload
      });

    case GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_EXPORT:
      return Object.assign({}, state, {
        getPreSalesReportPlannedFollowUpExport: payload
      });
    case GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_FILTER_PROJECT:
      return Object.assign({}, state, {
        getPreSalesReportPlannedFollowUpFilterProject: payload
      });

    case GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_FILTER_SOURCE:
      return Object.assign({}, state, {
        getPreSalesReportPlannedFollowUpFilterSource: payload
      });
    case GET_PRE_SALES_REPORT_PLANNED_FOLLOW_UP_FILTER_SOURCE_CATEGORY:
      return Object.assign({}, state, {
        getPreSalesReportPlannedFollowUpFilterSourceCategory: payload
      });
    case GET_PRE_SALES_REPORT_FOLLOW_UP:
      return {
        ...state,
        getPreSalesReportFollowUp: payload
      };

    case GET_PRE_SALES_REPORT_FOLLOW_UP_FILTER_PROJECT:
      return {
        ...state,
        getPreSalesReportFollowUpFilterProject: payload
      };

    case GET_PRE_SALES_REPORT_FOLLOW_UP_FILTER_SOURCE:
      return {
        ...state,
        getPreSalesReportFollowUpFilterSource: payload
      };

    case GET_PRE_SALES_REPORT_FOLLOW_UP_FILTER_SOURCE_CATEGORY:
      return {
        ...state,
        getPreSalesReportFollowUpFilterSourceCategory: payload
      };
    case GET_PRE_SALES_REPORT_FOLLOW_UP_EXPORT:
      return {
        ...state,
        getPreSalesReportFollowUpExport: payload
      };
    case GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT:
      return {
        ...state,
        getPreSalesReportActualSiteVisit: payload
      };
    case GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_EXPORT:
      return {
        ...state,
        getPreSalesReportActualSiteVisitExport: payload
      };

    case GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_FILTER_PROJECT:
      return {
        ...state,
        getPreSalesReportActualSiteVisitFilterProject: payload
      };

    case GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_FILTER_SOURCE:
      return {
        ...state,
        getPreSalesReportActualSiteVisitFilterSource: payload
      };

    case GET_PRE_SALES_REPORT_ACTUAL_SITE_VISIT_FILTER_SOURCE_CATEGORY:
      return {
        ...state,
        getPreSalesReportActualSiteVisitFilterSourceCategory: payload
      };

    case GET_PRE_SALES_REPORT_ACTUAL_SALES:
      return {
        ...state,
        getPreSalesReportActualSales: payload
      };

    case GET_PRE_SALES_REPORT_ACTUAL_SALES_EXPORT:
      return {
        ...state,
        getPreSalesReportActualSalesExport: payload
      };

    case GET_PRE_SALES_REPORT_ACTUAL_SALES_FILTER_PROJECT:
      return {
        ...state,
        getPreSalesReportActualSalesFilterProject: payload
      };

    case GET_PRE_SALES_REPORT_ACTUAL_SALES_FILTER_SOURCE:
      return {
        ...state,
        getPreSalesReportActualSalesFilterSource: payload
      };

    case GET_PRE_SALES_REPORT_ACTUAL_SALES_FILTER_SOURCE_CATEGORY:
      return {
        ...state,
        getPreSalesReportActualSalesFilterSourceCategory: payload
      };

    case GET_PRE_SALES_REPORT_CANCELLATION:
      return {
        ...state,
        getPreSalesReportCancellation: payload
      };
    case GET_PRE_SALES_REPORT_CANCELLATION_EXPORT:
      return {
        ...state,
        getPreSalesReportCancellationExport: payload
      };

    case GET_PRE_SALES_REPORT_CANCELLATION_FILTER_PROJECT:
      return {
        ...state,
        getPreSalesReportCancellationFilterProject: payload
      };

    case GET_PRE_SALES_REPORT_CANCELLATION_FILTER_SOURCE:
      return {
        ...state,
        getPreSalesReportCancellationFilterSource: payload
      };

    case GET_PRE_SALES_REPORT_CANCELLATION_FILTER_SOURCE_CATEGORY:
      return {
        ...state,
        getPreSalesReportCancellationFilterSourceCategory: payload
      };

    case GET_PRE_SALES_REPORT_SITE_VISIT_PREVIOUS_ENQUIRY:
      return {
        ...state,
        getPreSalesReportsiteVisitPreviousEnquiry: payload
      };

    case GET_PRE_SALES_REPORT_SITE_VISIT_PREVIOUS_ENQUIRY_EXPORT:
      return {
        ...state,
        getPreSalesReportsiteVisitPreviousEnquiryExport: payload
      };

    case GET_PRE_SALES_REPORT_SITE_VISIT_ENQUIRY_PROJECT:
      return {
        ...state,
        getPreSalesReportSiteVisitEnquiryFilterProject: payload
      };

    case GET_PRE_SALES_REPORT_SITE_VISIT_FILTER_ENQUIRY_SOURCE:
      return {
        ...state,
        getPreSalesReportSiteVisitEnquiryFilterSource: payload
      };

    case GET_PRE_SALES_REPORT_SITE_VISIT_ENQUIRY_FILTER_SOURCE_CATEGORY:
      return {
        ...state,
        getPreSalesReportSiteVisitEnquiryFilterSourceCategory: payload
      };

    //lead report

    case GET_LEAD_SALES_REPORT:
      return {
        ...state,
        getLeadSalesReport: payload
      };

    case GET_LEAD_SALES_REPORT_EXPORT:
      return {
        ...state,
        getLeadSalesReportExport: payload
      };

    case GET_LEAD_SALES_REPORT_FILTER_PROJECT:
      return {
        ...state,
        getLeadSalesReportFilterProject: payload
      };

    case GET_LEAD_SALES_REPORT_FILTER_CATEGORY:
      return {
        ...state,
        getLeadSalesReportFilterCategory: payload
      };

    case GET_LEAD_SALES_REPORT_FILTER_SOURCE:
      return {
        ...state,
        getLeadSalesReportFilterSource: payload
      };

    case GET_LEAD_SALES_REPORT_FILTER_SUB_SOURCE:
      return {
        ...state,
        getLeadSalesReportFilterSubSource: payload
      };

    case GET_LEAD_SALES_ENQUIRY_REPORT:
      return {
        ...state,
        getLeadSalesEnquiryReport: payload
      };

    case GET_LEAD_SALES_ENQUIRY_REPORT_EXPORT:
      return {
        ...state,
        getLeadSalesEnquiryReportExport: payload
      };
    case GET_SOURCE_SUMMARY_REPORT_ACTUAL_SITE_VISIT:
      return {
        ...state,
        getSourceSummaryReportActualSiteVisit: payload
      };
    case GET_SOURCE_SUMMARY_REPORT_ACTUAL_SITE_VISIT_EXPORT:
      return {
        ...state,
        getSourceSummaryReportActualSiteVisitExport: payload
      };
    case GET_SOURCE_SUMMARY_REPORT_ACTUAL_SALES:
      return {
        ...state,
        getSourceSummaryReportActualSales: payload
      };
    case GET_SOURCE_SUMMARY_REPORT_CANCELLATION:
      return {
        ...state,
        getSourceSummaryReportCancellation: payload
      };
    case GET_SOURCE_SUMMARY_REPORT_CANCELLATION_EXPORT:
      return {
        ...state,
        getSourceSummaryReportCancellationExport: payload
      };
    case GET_SOURCE_SUMMARY_ENQUIRY_REPORT_FILTER_PROJECT:
      return {
        ...state,
        getSourceSummaryEnquiryReportFilterProject: payload
      };
    case GET_SOURCE_SUMMARY_REPORT_ACTUAL_SITE_VISIT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSourceSummaryReportActualSiteVisitFilterProject: payload
      });
    case GET_SOURCE_SUMMARY_REPORT_ACTUAL_SALES_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSourceSummaryReportActualSalesFilterProject: payload
      });
    case GET_SOURCE_SUMMARY_REPORT_CANCELLATION_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSourceSummaryReportCancellationFilterProject: payload
      });

    //PROJECT FILTER

    case GET_SALES_REPORT_PLANNED_FOLLOWUP_FILTER_PROJECT:
      return {
        ...state,
        getSalesReportPlannedFollowUpFilterProject: payload
      };

    case GET_SALES_REPORT_FOLLOW_UP_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesReportFollowUpFilterProject: payload
      });

    case GET_SALES_REPORT_PLANNED_SITE_VISIT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesReportPlannedSiteVisitFilterProject: payload
      });

    case GET_SALES_REPORT_SITE_VISIT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesReportSiteVisitFilterProject: payload
      });
    case GET_SALES_REPORT_BOOKING_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesReportBookingFilterProject: payload
      });
    case GET_SALES_REPORT_CANCELLATION_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesReportCancellationFilterProject: payload
      });
    case GET_SALES_REPORT_AGREEMENT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesReportAgreementFilterProject: payload
      });
    case GET_SALES_REPORT_REGISTRATION_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesReportRegistrationFilterProject: payload
      });
    case GET_SALES_REPORT_BOOKING_GROSS_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesReportBookingGrossFilterProject: payload
      });
    case GET_SALES_REPORT_CANCELLATION_PREVIOUS_FILTER_REPORT:
      return Object.assign({}, state, {
        getSalesReportCancellationPreviousFilterReport: payload
      });
    case GET_SALES_REPORT_PLANNED_CP_MEETING_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesReportPlannedCpMeetingFilterProject: payload
      });
    case GET_SALES_REPORT_PLANNED_COMPLETED_CP_MEETING_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesReportCompletedCpMeetingFilterProject: payload
      });
    case GET_SALES_REPORT_PLANNED_CLIENT_MEETING_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesReportPlannedClientMeetingFilterProject: payload
      });
    case GET_SALES_REPORT_COMPLETED_CLIENT_MEETING_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesReportCompletedClientMeetingFilterProject: payload
      });
    case GET_SOURCE_SUMMARY_REPORT_ACTUAL_SALES_EXPORT:
      return Object.assign({}, state, {
        getSourceSummaryReportActualSalesExport: payload
      });

    case GET_CALL_SUMMARY_REPORT:
      return Object.assign({}, state, {
        getCallSummaryReport: payload
      });
    case GET_CALL_SUMMARY_REPORT_EXPORT:
      return Object.assign({}, state, {
        getCallSummaryReportExport: payload
      });
    case GET_CALL_SUMMARY_FILTER_EXECUTIVE:
      return Object.assign({}, state, {
        getCallSummaryReportFilterExecutive: payload
      });
    case GET_CALL_SUMMARY_TOTAL_CALL_REPORT:
      return Object.assign({}, state, {
        getCallSummaryTotalCallReport: payload
      });
    case GET_CALL_SUMMARY_TOTAL_CALL_REPORT_EXPORT:
      return Object.assign({}, state, {
        getCallSummaryTotalCallReportExport: payload
      });
    case GET_CALL_SUMMARY_REPEAT_CALL_REPORT:
      return Object.assign({}, state, {
        getCallSummaryRepeatCallReport: payload
      });
    case GET_CALL_SUMMARY_REPEAT_CALL_REPORT_EXPORT:
      return Object.assign({}, state, {
        getCallSummaryRepeatCallReportExport: payload
      });
    case GET_CALL_SUMMARY_FRESH_CALL_REPORT:
      return Object.assign({}, state, {
        getCallSummaryFreshCallReport: payload
      });
    case GET_CALL_SUMMARY_FRESH_CALL_REPORT_EXPORT:
      return Object.assign({}, state, {
        getCallSummaryFreshCallReportExport: payload
      });
    case GET_PROCUMENT_REPORT:
      return Object.assign({}, state, {
        getProcurmentReport: payload
      });
    case GET_PROCUMENT_REPORT_DETAIL:
      return Object.assign({}, state, {
        getProcurmentReportDetail: payload
      });
    case GET_PROCUMENT_REPORT_EXPORT:
      return Object.assign({}, state, {
        getProcurmentReportExport: payload
      });
    case GET_PROCUMENT_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getProcurmentReportFilterProject: payload
      });
    case GET_PROCUMENT_REPORT_FILTER_VENDOR:
      return Object.assign({}, state, {
        getProcurmentReportFilterVendor: payload
      });
    case GET_PROCUMENT_REPORT_FILTER_ITEM:
      return Object.assign({}, state, {
        getProcurmentReportFilterItem: payload
      });

    //civil budget report
    case GET_CIVIL_PROJECT_BUDGET_REPORT:
      return Object.assign({}, state, {
        getCivilProjectBudgetReport: payload
      });

    case GET_CIVIL_PROJECT_BUDGET_REPORT_EXPORT:
      return Object.assign({}, state, {
        getCivilProjectBudgetReportExport: payload
      });

    case GET_CIVIL_ACTIVITY_BUDGET_REPORT:
      return Object.assign({}, state, {
        getCivilActivityBudgetReport: payload
      });

    case GET_CIVIL_ACTIVITY_BUDGET_REPORT_EXPORT:
      return Object.assign({}, state, {
        getCivilActivityBudgetReportExport: payload
      });

    case GET_CIVIL_WBS_BUDGET_REPORT:
      return Object.assign({}, state, {
        getCivilWbsBudgetReport: payload
      });

    case GET_CIVIL_WBS_BUDGET_REPORT_EXPORT:
      return Object.assign({}, state, {
        getCivilWbsBudgetReportExport: payload
      });

    case GET_CIVIL_PROJECT_BUDGET_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getCivilProjectBudgetReportFilterProject: payload
      });

    case GET_CIVIL_WBS_BUDGET_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getCivilWbsBudgetReportFilterProject: payload
      });
    case GET_CIVIL_WBS_BUDGET_REPORT_FILTER_WBS:
      return Object.assign({}, state, {
        getCivilWbsBudgetReportFilterWbs: payload
      });

    case GET_CIVIL_ACTIVITY_BUDGET_REPORT_FILTER_WBS:
      return Object.assign({}, state, {
        getCivilActivityBudgetReportFilterWbs: payload
      });

    case GET_CIVIL_ACTIVITY_BUDGET_REPORT_FILTER_ACTIVITY:
      return Object.assign({}, state, {
        getCivilActivityBudgetReportFilterActivity: payload
      });
    case GET_CIVIL_ACTIVITY_BUDGET_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getCivilActivityBudgetReportFilterProject: payload
      });
    case GET_CIVIL_ACTIVITY_BUDGET_REPORT_ACTUAL_MATERIAL:
      return Object.assign({}, state, {
        getCivilActivityBudgetReportActualMaterial: payload
      });
    case GET_CIVIL_ACTIVITY_BUDGET_REPORT_ACTUAL_MATERIAL_EXPORT:
      return Object.assign({}, state, {
        getCivilActivityBudgetReportActualMaterialExport: payload
      });

    case GET_SOURCE_CATEGORY_SUMMARY_REPORT:
      return Object.assign({}, state, {
        getSourceCategorySummaryReport: payload
      });

    case GET_SUB_SOURCE_CATEGORY_SUMMARY_REPORT:
      return Object.assign({}, state, {
        getSubSourceSummaryReport: payload
      });

    case GET_SOURCE_CATEGORY_SUMMARY_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSourceCategorySummaryReportExport: payload
      });

    case GET_SUB_SOURCE_CATEGORY_SUMMARY_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSubSourceSummaryReportExport: payload
      });

    case GET_CIVIL_PROJECT_BEDGET_REPORT_ADMIN_EXPENSE:
      return Object.assign({}, state, {
        getCivilProjectBudgetReportAdminExpense: payload
      });
    case GET_CIVIL_PROJECT_BEDGET_REPORT_ADMIN_EXPENSE_EXPORT:
      return Object.assign({}, state, {
        getCivilProjectBudgetReportAdminExpenseExport: payload
      });

    case GET_CIVIL_PROJECT_BEDGET_REPORT_PETTY_CASH:
      return Object.assign({}, state, {
        getCivilProjectBudgetReportPettyCash: payload
      });

    case GET_CIVIL_PROJECT_BEDGET_REPORT_PETTY_CASH_EXPORT:
      return Object.assign({}, state, {
        getCivilProjectBudgetReportPettyCashExport: payload
      });

    //project DASHBOARD
    case GET_BD_PROJECT_DASHBOARD:
      return Object.assign({}, state, {
        getBDProjectDashboard: payload
      });

    case GET_BD_PROJECT_CONSOLIDATED_DASHBOARD:
      return Object.assign({}, state, {
        getBdProjectConsolidatedDashboard: payload
      });
    case GET_BD_PROJECT_CONSOLIDATED_DASHBOARD_EXPORT:
      return Object.assign({}, state, {
        getBdProjectConsolidatedDashboardExport: payload
      });
    case GET_BD_PROJECT_CONSOLIDATED_DASHBOARD_MD:
      return Object.assign({}, state, {
        getBdProjectConsolidatedDashboardMD: payload
      });
    case GET_COURT_CASE_DASHBOARD:
      return Object.assign({}, state, {
        getCourtCaseDashboard: payload
      });

    case GET_COURT_CASE_DASHBOARD_EXPORT:
      return Object.assign({}, state, {
        getCourtCaseDashboardExport: payload
      });

    case GET_BD_LAND_DISPUTE_DASHBOARD:
      return Object.assign({}, state, {
        getBdLandDisputeDashboard: payload
      });

    case GET_BD_LAND_DISPUTE_DASHBOARD_EXPORT:
      return Object.assign({}, state, {
        getBdLandDisputeDashboardExport: payload
      });

    case GET_BD_LEGAL_DASHBOARD:
      return Object.assign({}, state, {
        getBdLegalDashboard: payload
      });

    case GET_BD_LEGAL_DASHBOARD_EXPORT:
      return Object.assign({}, state, {
        getBdLegalDashboardExport: payload
      });

    case GET_LIAISON_PROSESS_PLAN_DASHBOARD:
      return Object.assign({}, state, {
        getLiaisonProcessPlanDashboard: payload
      });
    case GET_LIAISON_PROSESS_PLAN_DASHBOARD_EXPORT:
      return Object.assign({}, state, {
        getLiaisonProcessPlanDashboardExport: payload
      });
    case GET_LIAISON_DOCUMENTAION_TASK_PLAN_DASHBOARD:
      return Object.assign({}, state, {
        getLiaisonDocumentationTaskPlanDashboard: payload
      });
    case GET_LIAISON_DOCUMENTAION_TASK_PLAN_DASHBOARD_EXPORT:
      return Object.assign({}, state, {
        getLiaisonDocumentationTaskPlanDashboardExport: payload
      });

    case GET_PROJECT_FILE_AQUISTION_PENDING_DASHBOARD:
      return Object.assign({}, state, {
        getProjectFileAcquisitionPendingDashboard: payload
      });
    case GET_PROJECT_FILE_AQUISTION_PENDING_DASHBOARD_EXPORT:
      return Object.assign({}, state, {
        getProjectFileAcquisitionPendingDashboardExport: payload
      });

    case GET_APF_TASK_PLAN_QUERY_DASHBOARD:
      return Object.assign({}, state, {
        getApfTaskPlanQueryDashboard: payload
      });

    case GET_APF_TASK_PLAN_QUERY_DASHBOARD_EXPORT:
      return Object.assign({}, state, {
        getApfTaskPlanQueryDashboardExport: payload
      });

    //SITE SUMMARY
    case GET_SITE_SUMMARY_REPORT:
      return Object.assign({}, state, {
        getSiteSummaryReport: payload
      });
    case GET_SITE_SUMMARY_DETAIL_REPORT:
      return Object.assign({}, state, {
        getSiteSummaryDetailReport: payload
      });
    case GET_SITE_STATUS:
      return Object.assign({}, state, {
        getSiteStatus: payload
      });
    case GET_SITE_SUMMARY_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSiteSummaryReportFilterProject: payload
      });
    case GET_SITE_SUMMARY_DETAIL_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSiteSummaryDetailReportFilterProject: payload
      });
    case GET_SITE_SUMMARY_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSiteSummaryReportExport: payload
      });
    case GET_SITE_SUMMARY_DETAIL_REPORT_EXPORT:
      return Object.assign({}, state, {
        getSiteSummaryDetailReportExport: payload
      });

    case GET_BD_PROJECT_AQUISTION_DASHBOARD_FILTER_PROJECT:
      return Object.assign({}, state, {
        getProjectFileAcquisitionDashboardFilterProject: payload
      });

    case GET_TASK_DASHBOARD:
      return Object.assign({}, state, {
        getTaskDashboard: payload
      });
    case GET_TASK_DASHBOARD_EXPORT:
      return Object.assign({}, state, {
        getTaskDashboardExport: payload
      });

    //ORG CHART
    case GET_ORGANIZATION_STRUCTURE:
      return Object.assign({}, state, {
        getOrganizationStructure: payload
      });

    case GET_CIVIL_WBS_PROGRESS:
      return Object.assign({}, state, {
        getCivilWbsProgress: payload
      });

    case GET_CIVIL_ACTIVITY_PROGRESS:
      return Object.assign({}, state, {
        getCivilActivityProgress: payload
      });

    case GET_CIVIL_WBS_PROGRESS1:
      return Object.assign({}, state, {
        getCivilWbsProgress1: payload
      });

    case GET_CIVIL_ACTIVITY_PROGRESS1:
      return Object.assign({}, state, {
        getCivilActivityProgress1: payload
      });

    //MD Dashboard
    case GET_MOU_DASHBOARD:
      return Object.assign({}, state, {
        getMouDashboard: payload
      });
    case GET_MOU_DASHBOARD_EXPORT:
      return Object.assign({}, state, {
        getMouDashboardExport: payload
      });
    case GET_ACQUISITION_DASHBOARD:
      return Object.assign({}, state, {
        getAcquisitionDashboard: payload
      });
    case GET_ACQUISITION_DASHBOARD_EXPORT:
      return Object.assign({}, state, {
        getAcquisitionDashboardExport: payload
      });

    case GET_COMPLIANCE_ITEM_REPORT:
      return Object.assign({}, state, {
        getComplianceItemReport: payload
      });
    case GET_COMPLIANCE_ITEM_REPORT_DETAIL:
      return Object.assign({}, state, {
        getComplianceItemReportDetail: payload
      });
    // Compliance Report
    case GET_COMPLIANCE_ITEM_HR_REPORT:
      return Object.assign({}, state, {
        getComplianceItemHrReport: payload
      });
    case GET_COMPLIANCE_ITEM_HR_REPORT_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getComplianceItemHrReportFilterCategory: payload
      });
    case GET_COMPLIANCE_GST_REPORT_FILTER_COMPANY:
      return Object.assign({}, state, {
        getComplianceGstReportFilterCompany: payload
      });
    case GET_COMPLIANCE_ITEM_HR_REPORT_FILTER_COMPANY:
      return Object.assign({}, state, {
        getComplianceHrReportFilterCompany: payload
      });
    case GET_COMPLIANCE_ITEM_ITR_REPORT:
      return Object.assign({}, state, {
        getComplianceItemItrReport: payload
      });
    case GET_COMPLIANCE_ITR_REPORT_FILTER_COMPANT:
      return Object.assign({}, state, {
        getComplianceItrReportFilterCompany: payload
      });
    case GET_COMPLIANCE_ITEM_TDS_REPORT:
      return Object.assign({}, state, {
        getComplianceItemTdsReport: payload
      });
    case GET_COMPLIANCE_TDS_REPORT_FILTER_COMPANY:
      return Object.assign({}, state, {
        getComplianceTdsReportFilterCompany: payload
      });
    // Qc Report
    case GET_QC_WORK_REPORT:
      return Object.assign({}, state, {
        getQcWorkReport: payload
      });
    case GET_QC_WORK_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getQcWorkReportFilterProject: payload
      });
    case GET_QC_WORK_REPORT_PASSING_DETAIL:
      return Object.assign({}, state, {
        getQcWorkReportPassingDetail: payload
      });
    case GET_QC_OBSERVATION_REPORT_PASSING_DETAIL:
      return Object.assign({}, state, {
        getQcObservationReportPassingDetail: payload
      });

    case GET_QC_WORK_REPORT_PASSING_DETAIL_EXPORT:
      return Object.assign({}, state, {
        getQcWorkReportPassingDetailExport: payload
      });
    case GET_QC_OBSERVATION_REPORT_PASSING_DETAIL_EXPORT:
      return Object.assign({}, state, {
        getQcObservationReportPassingDetailExport: payload
      });

    // Qc Observation
    case GET_QC_OBSERVATION_REPORT:
      return Object.assign({}, state, {
        getQcObservationReport: payload
      });
    case GET_QC_OBSERVATION_REPORT_HANDLED_BY:
      return Object.assign({}, state, {
        getQcObservationReportHandledBy: payload
      });
    case GET_QC_OBSERVATION_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getQcObservationReportFilterProject: payload
      });
    case GET_QC_WORK_REPORT_FILTER_HANDLED_BY:
      return Object.assign({}, state, {
        getQcWorkReportFilterHandledBy: payload
      });
    case GET_QC_WORK_REPORT_DETAIL:
      return Object.assign({}, state, {
        getQcWorkReportDetail: payload
      });
    case GET_QC_WORK_REPORT_FILTER_RAISED_BY:
      return Object.assign({}, state, {
        getQcWorkReportFilterRaisedBy: payload
      });

    case GET_QC_WORK_REPORT_EXPORT:
      return Object.assign({}, state, {
        getQcWorkReportExport: payload
      });

    case GET_QC_OBSERVATION_REPORT_FILTER_HANDLED_BY:
      return Object.assign({}, state, {
        getQcObservationReportFilterHandledBy: payload
      });
    case GET_QC_OBSERVATION_REPORT_DETAIL:
      return Object.assign({}, state, {
        getQcObservationReportDetail: payload
      });
    case GET_QC_OBSERVATION_REPORT_DETAIL_EXPORT:
      return Object.assign({}, state, {
        getQcObservationReportDetailExport: payload
      });
    case GET_QC_OBSERVATION_REPORT_FILTER_RAISED_BY:
      return Object.assign({}, state, {
        getQcObservationReportFilterRaisedBy: payload
      });
    case GET_QC_OBSERVATION_REPORT_EXPORT:
      return Object.assign({}, state, {
        getQcObservationReportExport: payload
      });

    // QC WalkThrough

    case GET_QC_WALK_THROUGH_REPORT:
      return Object.assign({}, state, {
        getQcWalkthroughReport: payload
      });
    case GET_QC_WALK_THROUGH_REPORT_EXPORT:
      return Object.assign({}, state, {
        getQcWalkthroughReportExport: payload
      });

    case GET_QC_WALK_THROUGH_REPORT_DETAIL:
      return Object.assign({}, state, {
        getQcWalkthroughReportDetail: payload
      });
    case GET_QC_WALK_THROUGH_REPORT_DETAIL_EXPORT:
      return Object.assign({}, state, {
        getQcWalkthroughReportDetailExport: payload
      });
    case GET_QC_WALK_THROUGH_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getQcWalkthroughReportFilterProject: payload
      });

    // QC Training
    case GET_QC_TRAINING_REPORT:
      return Object.assign({}, state, {
        getQcTrainingReport: payload
      });
    case GET_QC_TRAINING_REPORT_EXPORT:
      return Object.assign({}, state, {
        getQcTrainingReportExport: payload
      });
    case GET_QC_TRAINING_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getQcTrainingReportFilterProject: payload
      });
    case GET_QC_TRAINING_REPORT_DETAIL:
      return Object.assign({}, state, {
        getQcTrainingReportDetail: payload
      });
    case GET_QC_TRAINING_REPORT_DETAIL_EXPORT:
      return Object.assign({}, state, {
        getQcTrainingReportDetailExport: payload
      });
    // Qc Report
    case GET_QC_INSPECTION_REPORT:
      return Object.assign({}, state, {
        getQcInspectionReport: payload
      });
    case GET_QC_INSPECTION_REPORT_EXPORT:
      return Object.assign({}, state, {
        getQcInspectionReportExport: payload
      });
    case GET_QC_INSPECTION_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getQcInspectionReportFilterProject: payload
      });

    case GET_QC_INSPECTION_REPORT_DETAIL:
      return Object.assign({}, state, {
        getQcInspectionReportDetail: payload
      });
    case GET_QC_INSPECTION_REPORT_DETAIL_EXPORT:
      return Object.assign({}, state, {
        getQcInspectionReportDetailExport: payload
      });
    //Crm Booking Report
    case GET_CRM_BOOKING_REPORT:
      return Object.assign({}, state, {
        getCrmBookingReport: payload
      });
    case GET_CRM_BOOKING_REPORT_EXPORT:
      return Object.assign({}, state, {
        getCrmBookingReportExport: payload
      });
    case GET_CRM_BOOKING_REPORT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getCrmBookingReportFilterProject: payload
      });
    case GET_CRM_BOOKING_REPORT_FILTER_SITE:
      return Object.assign({}, state, {
        getCrmBookingReportFilterSite: payload
      });
    case GET_CRM_BOOKING_REPORT_FILTER_CRM_USER:
      return Object.assign({}, state, {
        getCrmBookingReportFilterCrmUser: payload
      });
    case GET_CRM_BOOKING_REPORT_FILTER_SITE_STATUS:
      return Object.assign({}, state, {
        getCrmBookingReportFilterSiteStatus: payload
      });
    case GET_CRM_BOOKING_REPORT_DETAIL:
      return Object.assign({}, state, {
        getCrmBookingReportDetail: payload
      });
    default:
      return state;
  }
};

export default Report_reducer;
